<template>
  <div>
    <div class="white-wrapper mb-4">
      <div class="section-title mb-4">{{ $t("scheduleOverview") }}</div>
      <div class="row">
        <div class="col-lg-4 col-xl-3 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <multiselect
              v-model="selectedCinema"
              :placeholder="'Select Cinema'"
              :options="Cinemas"
              label="cine_name"
              track-by="cine_id"
              :multiple="false"
              @select="onSelectCinema($event)"
            ></multiselect>
          </div>
        </div>
        <div class="col-lg-3 col-xl-2 align-self-center mb-4">
          <div class="input-material">
            <div class="add-datepicker">
              <Datepicker
                :monday-first="true"
                ref="programaticOpen"
                v-model="start_date"
                name="selectenddate_1"
                id="selectenddate_1"
                v-validate="'required'"
                @input="onChangeDate('start_date')"
                @selected-disabled="onClickDisableDates()"
                :typeable="true"
              ></Datepicker>
              <label :class="start_date ? 'active' : ''">{{
                $t("fromdate")
              }}</label>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-xl-2 align-self-center mb-4">
          <div class="input-material">
            <div class="add-datepicker">
              <Datepicker
                :monday-first="true"
                ref="programaticOpen"
                v-model="end_date"
                name="selectenddate_1"
                id="selectenddate_1"
                v-validate="'required'"
                :typeable="true"
                @input="onChangeDate('end_date')"
              ></Datepicker>
              <!-- :disabledDates="disabledDatesTo" -->

              <label :class="end_date ? 'active' : ''">{{
                $t("todate")
              }}</label>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-xl-3 d-flex">
          <div class="dropdown-curve-container">
            <multiselect
              class=""
              :allow-empty="false"
              v-model="showTypeFilter"
              placeholder="Select Show Type"
              :options="scheduleStatusArray"
              @select="onSelectShowType($event)"
              label="type"
              track-by="type"
              :multiple="false"
            ></multiselect>
            <label :class="showTypeFilter ? 'shift-up' : ''">
              {{ $t("Type") }}
            </label>
          </div>
        </div>
        <div class="col-lg-6 col-xl-2 d-flex">
          <div class="dropdown-curve-container">
            <multiselect
              class=""
              :allow-empty="false"
              v-model="selectedScreendd"
              placeholder="Select Show Type"
              :options="screenList"
              @select="onSelectScreen($event)"
              label="screen_name"
              track-by="screen_id"
              :multiple="false"
            ></multiselect>
            <label :class="selectedScreendd ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("screen", 1) }}</label
            >
          </div>
        </div>
      </div>

      <div class="">
        <div class="d-flex justify-content-end align-items-center mb-3">
          <div class="d-flex align-items-center">
            <div class="mx-2 d-flex">
              <button
                class="btn btn-sm btn-blue btn-delete br-20 h-29 p-0"
                :class="selected_schedule_length == 0 ? 'disDeleteBtn' : ''"
                v-if="allowDeleteSchedule"
                :disabled="selected_schedule_length == 0"
                @click="$bvModal.show('delete_muliple_confirmation')"
              >
                ({{ selected_schedule_length }}) Delete
              </button>
              <button
                class="btn btn-sm btn-outline-blue br-20 h-29 p-0"
                v-if="allowDeleteSchedule"
                @click="
                  allowDeleteSchedule = false;
                  selected_delete_schedule = [];
                  selectAllMoviesDel = false;
                "
              >
                Cancel
              </button>
            </div>

            <div class="mx-2 d-flex">
              <button
                class="btn btn-sm btn-blue btn-planned br-20 h-29 p-0"
                :class="
                  selected_planned_schedule_length == 0 ? 'disDeleteBtn' : ''
                "
                v-if="allowChangePlannedSchedule"
                :disabled="selected_planned_schedule_length == 0"
                @click="$bvModal.show('open_muliple_planned_confirmation')"
              >
                ({{ selected_planned_schedule_length }}) Schedule
              </button>
              <button
                class="btn btn-sm btn-outline-blue br-20 h-29 p-0"
                v-if="allowChangePlannedSchedule"
                @click="
                  allowChangePlannedSchedule = false;
                  selected_planned_schedule = [];
                  selectAllPlannedMovie = false;
                "
              >
                Cancel
              </button>
            </div>
          </div>
          <div v-if="filteredScheduleArray.length > 0" class="d-flex justify-content-end align-items-center">
  <div>{{ $t("download") }} as:</div>
  <!-- <div @click="getScheduleOverview('Y')"></div> -->
  <img
  v-if='isStar'
    @click="getScheduleOverview('Y')"
    class="mx-1 cursor-pointer"
    src="@/assets/img/icons/pdf.svg"
    height="25"
    width="25"
  />
  <a
    :href="BASE_URL + `/api/admin/export_schedule_list${queryString}`"
    target="_blank"
    title="Download as Excel"
    download
  >
    <img
      class="mx-1"
      src="@/assets/img/icons/excel.svg"
      height="25"
      width="25"
    />
  </a>
</div>

          <div
            class="icon-delete-red blue-icon mx-1 btn"
            v-if="!allowDeleteSchedule && status != 17"
            :title="'Delete Schedule'"
            @click="onClickDeleteMultipleBtn()"
          ></div>
          <div
            class="icon-open-planned blue-icon mx-1 btn"
            v-if="!allowChangePlannedSchedule && status == 19 && !gridView"
            :title="'Open Planned Schedule'"
            @click="onClickSchPlannedMultipleBtn()"
          ></div>
          <div
            class="icon-dragndrop blue-icon mx-1 btn"
            @click="
              $router.push({
                path: 'view-schedule-dd',
              })
            "
            :title="'Schedule Drag & Drop'"
          ></div>
          <div
            class="icon-calendar_list blue-icon mx-1 btn"
            :title="'List View'"
            :class="!gridView ? 'disableViewBtn' : ''"
            :disabled="!gridView"
            @click="viewType('list')"
          ></div>
          <div
            class="icon-grid-view blue-icon mx-1 btn"
            :title="'Grid View'"
            :disabled="gridView"
            :class="gridView ? 'disableViewBtn' : ''"
            @click="viewType('grid')"
          ></div>
          <div
            class="zoomInBtnl"
            :class="zoomLevel == 1 ? 'disable' : ''"
            @click="zoomIn('minus')"
          >
            <span>-</span>
          </div>
          <div
            class="zoomInBtnl"
            :class="zoomLevel == 4 ? 'disable' : ''"
            @click="zoomIn('add')"
          >
            <span>+</span>
          </div>
          <div
            class="d-flex justify-content-end align-items-center"
            style="zoom: 0.8"
            v-if="!gridView"
          >
            <div class="d-flex align-items-center">
              <div class="mx-2">
                <b-dropdown id="listview" variant="outline-blue">
                  <template v-slot:button-content>
                    Viewing&nbsp;
                    <strong>{{ selectedvalue }}</strong>
                    &nbsp;Of&nbsp;
                    <strong>{{ rows }}</strong>
                  </template>
                  <b-dropdown-item
                    v-for="(list, listIndex) in viewingnumbers"
                    :key="listIndex"
                    @click="onDropDownChangeValue(list.name)"
                    href="#"
                    >{{ list.name }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>
          </div>
        </div>
        <div class="" :style="'zoom:' + zoomIndex + ';overflow-x: auto;'">
          <div style="display: flex" class="hidden">
            <table
              class="schedule-overview-table-time border"
              v-if="gridView"
              :class="filteredScheduleArray.length == 0 ? 'w-100' : ''"
            >
              <thead v-if="filteredScheduleArray.length > 0">
                <tr
                  v-for="(item, index) in 3"
                  :key="index"
                  :class="
                    index == 0
                      ? 'table-header-row'
                      : index == 1
                      ? 'table-header-subcol'
                      : ''
                  "
                >
                  <th
                    :style="
                      index == 2
                        ? 'width:40px;height:' +
                          parseInt(getMaxLengthNew) +
                          'px'
                        : ''
                    "
                    :class="index == 2 ? 'box-size-screen-time' : ''"
                    class="screenCol-time p-0"
                    style="height: 22px"
                  >
                    <div></div>
                    <div
                      v-if="index == 2"
                      v-for="(time, indexnew) in time_range"
                      :key="indexnew"
                      class=""
                      :style="
                        'position:absolute;    font-size: 12px !important;height:908px;max-height:10px;top:' +
                          getHourWidth(indexnew) +
                          'px'
                      "
                    >
                      <hr
                        :style="
                          filteredScheduleArray.length < 5
                            ? 'max-width:' +
                              getMaxHorizonLen(filteredScheduleArray) +
                              'px;!important'
                            : ''
                        "
                        class="horizontal_line"
                      />
                      {{ time }}
                    </div>
                    <div v-if="index < 2" style="opacity: 0">1</div>
                  </th>
                </tr>
              </thead>
            </table>
            <div class="swc-report">
              <table
                class="schedule-overview-table border mb-3"
                v-if="gridView"
                :class="filteredScheduleArray.length == 0 ? 'w-100' : ''"
              >
                <thead v-if="filteredScheduleArray.length > 0">
                  <tr
                    v-for="(item, index) in 3"
                    :key="index"
                    :class="
                      index == 0
                        ? 'table-header-row'
                        : index == 1
                        ? 'table-header-subcol'
                        : ''
                    "
                  >
                    <template v-for="item in filteredScheduleArray">
                      <th
                        class="br1 p-0"
                        :colspan="item.screen_array.length"
                        v-if="index == 0"
                        :key="item.show_date"
                      >
                        {{ item.show_date || fulldatemonparse }} &nbsp;<span
                          class="fs-12"
                          >({{ moment(item.show_date).format("dddd") }})</span
                        >
                      </th>
                      <th
                        v-else-if="index == 1 || index == 2"
                        v-for="(screen, screenIndex) in item.screen_array"
                        :key="'new-' + item.show_date + screenIndex"
                        :style="
                          index == 2
                            ? 'height:' + parseInt(getMaxLengthNew) + 'px'
                            : ''
                        "
                        class="screenCol"
                        :class="
                          screenIndex == item.screen_array.length - 1
                            ? index == 1
                              ? 'p-0 br1'
                              : index == 2
                              ? 'box-size-screen br1'
                              : ''
                            : index == 1
                            ? 'p-0 '
                            : index == 2
                            ? 'box-size-screen '
                            : ''
                        "
                      >
                        <div v-if="index == 1" :key="'header-' + screenIndex">
                          {{ screen.screen_name }}
                        </div>

                        <div
                          v-if="index == 2"
                          v-for="(movie, movieIndex) in screen.shows"
                          :key="'headermovie-' + movieIndex"
                          class="movie-box p-2 mb-2"
                          @click="onSelectMovieGridView(movie, movieIndex)"
                          :class="[
                            checkMovieSelected(movie) ? 'selected-border' : '',
                            checkIndicator(movie) ? 'indicator-border' : '',
                          ]"
                          :style="
                            'position:absolute;background-color:' +
                              movie.backgroundColor +
                              ';top:' +
                              getTopSize(movie.show_time_in_number) +
                              ';height:' +
                              getMovieBoxHeight(movie.show_time_in_min)
                          "
                        >
                          <div></div>
                          <div class="schedule-content">
                            <div class="d-flex flex-column w-100">
                              <div
                                class="d-flex flex-column w-100"
                                style="cursor: pointer"
                              >
                                <div class="d-flex">
                                  <strong
                                    class="truncate-text"
                                    style="font-size: 10px"
                                    v-b-popover.hover.left="{
                                      title: `<div class='fs-14' style='zoom:${zoomIndex}'> ${movie.movie}</div>`,
                                      customClass: `my-popover-class ${getPopOverClassName(
                                        movie
                                      )} ${
                                        zoomIndex == 0.6
                                          ? 'zoom06'
                                          : zoomIndex == 0.8
                                          ? 'zoom08'
                                          : zoomIndex == 1.2
                                          ? 'zoom12'
                                          : 'zoom1'
                                      }`,
                                      content: `
                          <div class='row fs-13'>
                          <div class='col-4 mr-0 pr-0'><b>Show Time<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'>${movie.ss_start_show_time ||
                            movie.start_time}-${movie.ss_end_show_time ||
                                        movie.end_time}</div>
                          <div class='col-4 mr-0 pr-0'><b>Day/Date<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'> ${moment(
                            movie.ss_actual_start_date
                          ).format('Do, MMMM (ddd)')}</div>
                          <div class='col-4 mr-0 pr-0'><b>Duration<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'>${movie.mrrdr_runtime ||
                            '-'} mins</div>
                          <div class='col-4 mr-0 pr-0'><b>Sound Format<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'>${movie.sound_format_name ||
                            '-'}</div>
                          <div class='col-4 mr-0 pr-0'><b>Occupancy<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'>${
                            movie.booked_seats
                          } Booked/ ${movie.unpaid_count} Unpaid/ ${
                                        movie.screen_total_seats
                                      } Seats</div>
                              ${
                                movie.ss_comment
                                  ? `
                          <div class='col-4 mr-0 pr-0'><b>Comment<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'>${movie.ss_comment}</div>
                          `
                                  : ``
                              }
                          ${
                            movie.sales_channel &&
                            movie.sales_channel.length > 0
                              ? `
                          <div class='col-4 mr-0 pr-0 mt-3'><b>Sales Channel<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0 mt-3'>${movie.sales_channel
                            .map((x) => x.username)
                            .join(', ')}</div>
                          `
                              : `<div class='col-4 mr-0 pr-0 mt-3'><b>Sales Channel<span class='float-right mr-2'>:</span></b></div>
                              <div class='col-8 ml-0 pl-0 mt-3 text-danger'>Not Selected</div>`
                          }
                          </div>
                          `,
                                      html: true,
                                    }"
                                    >{{ movie.movie || movie.movie_title }}
                                  </strong>

                                  <b-dropdown
                                    v-if="
                                      movie.mycinema_booking_type_id != 3 ||
                                        !allowDeleteSchedule
                                    "
                                    right
                                    variant="edit"
                                    id="dropdown-dropright"
                                    dropright
                                    boundary="viewport"
                                    class="align-self-end"
                                  >
                                    <b-dropdown-item
                                      @click="onClickViewSeatLayout(movie)"
                                      >View Seat Layout</b-dropdown-item
                                    >
                                    <b-dropdown-item
                                      @click="
                                        onEditMovie(movie, screen, screenIndex)
                                      "
                                      v-if="movie.ss_show_status != '13'"
                                      >Edit</b-dropdown-item
                                    >
                                    <b-dropdown-item
                                      @click="
                                        onEditMovie(movie, screen, screenIndex)
                                      "
                                      v-if="movie.ss_show_status == '13'"
                                      >View</b-dropdown-item
                                    >
                                    <b-dropdown-item
                                      v-if="
                                        movie.ss_show_status != '13' &&
                                          movie.mycinema_booking_type_id != 3
                                      "
                                      v-on:click="
                                        onDeleteMovieModal(
                                          screen,
                                          movie,
                                          screenIndex,
                                          movieIndex
                                        )
                                      "
                                      >Delete</b-dropdown-item
                                    >
                                    <b-dropdown-item
                                      v-if="
                                        movie.ss_show_status != '13' &&
                                          movie.mycinema_booking_type_id != 3
                                      "
                                      v-on:click="
                                        onClickEnableDisableSchedule(movie)
                                      "
                                      >{{
                                        movie.is_sch_disable == "N"
                                          ? "Disable Schedule"
                                          : "Enable Schedule"
                                      }}</b-dropdown-item
                                    >
                                    <b-dropdown-item
                                      @click="
                                        $router.push({
                                          name: 'Transactions',
                                          query: {
                                            cinema_id: screen.cinema_id,
                                            date: moment(
                                              movie.ss_start_date
                                            ).format('YYYY-MM-DD'),
                                            md_id: movie.md_id,
                                            ss_id: movie.ss_id,
                                          },
                                        })
                                      "
                                      >View Transactions</b-dropdown-item
                                    >
                                    <b-dropdown-item
                                      @click="
                                        $router.push({
                                          name: 'Unpaid Bookings',
                                          query: {
                                            cinema_id: screen.cinema_id,
                                            date: moment(
                                              movie.ss_start_date
                                            ).format('YYYY-MM-DD'),
                                            md_id: movie.md_id,
                                            ss_id: movie.ss_id,
                                          },
                                        })
                                      "
                                      >View Unpaid Bookings</b-dropdown-item
                                    >
                                    <b-dropdown-item
                                      v-if="movie.mycinema_booking_type_id == 3"
                                      @click="showAdmitModal(movie)"
                                      >Update Admits</b-dropdown-item
                                    >
                                  </b-dropdown>
                                </div>
                                <small class="truncate-text">
                                  {{
                                    movie.start_time + " - " + movie.end_time
                                  }}
                                </small>
                                <small
                                  class="truncate-text"
                                  v-if="
                                    !movie.isCrowdSource &&
                                      movie.mycinema_booking_type_id != 3 &&
                                      !movie.isNewSchedule
                                  "
                                >
                                  <span
                                    >({{ movie.booked_seats }} /
                                    {{ movie.unpaid_count }} /
                                    {{ movie.screen_total_seats }}
                                    Seats)</span
                                  >
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </th>
                    </template>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <table
            v-if="gridView && filteredScheduleArray.length == 0"
            class="list-view-table border"
          >
            <tbody>
              <td colspan="12">
                <NoRecords />
              </td>
            </tbody>
          </table>

          <!---Pdf export table start-->
          <div class="d-none">
            <vue-html2pdf
              :show-layout="true"
              :float-layout="false"
              :enable-download="false"
              :paginate-elements-by-height="1400"
              :pdf-quality="2"
              :manual-pagination="false"
              pdf-format="a2"
              pdf-orientation="landscape"
              pdf-content-width="100%"
              ref="html2Pdf"
              @beforeDownload="beforeDownload($event)"
            >
              <table
                class="schedule-overview-table border mb-3 p-0"
                border="1"
                v-if="!gridView"
                style="table-layout: fixed"
                slot="pdf-content"
              >
                <thead v-if="filteredScheduleArray.length > 0">
                  <tr class="bg-lightgrey pdf_table" style="color: black">
                    <th :title="'Date'">Date</th>
                    <th :title="'Screen'" class="">Screen</th>
                    <th :title="'Movie'" colspan="2">Movie</th>
                    <th :title="'Start Time'">Show Time</th>
                    <th :title="'Distributor'">Distributor</th>
                    <th :title="'Rate Card Details'" colspan="2">
                      Rate Card Details
                    </th>
                    <th :title="'Occupancy'" style="">Occupancy</th>
                  </tr>
                </thead>
                <tbody v-if="filteredScheduleArray.length > 0">
                  <tr
                    v-for="(date, dateIndex) in filteredScheduleArray"
                    :key="dateIndex"
                    class="rowDivider"
                  >
                    <td colspan="11" class="p-0">
                      <table class="w-100 p-0" style="table-layout: fixed">
                        <tr
                          v-for="(screen, screenIndex) in date.screen_array"
                          :key="screenIndex"
                        >
                          <td colspan="9" class="p-0">
                            <table
                              class="w-100 p-0"
                              style="table-layout: fixed"
                            >
                              <tr
                                v-for="(movie, movieIndex) in screen.shows"
                                :key="movieIndex"
                              >
                                <td
                                  v-b-popover.hover.bottom="{
                                    content: `${date.show_date}`,
                                    html: true,
                                  }"
                                  style="padding: 10px"
                                >
                                  {{ date.show_date }}
                                  <span
                                    class="fs-12"
                                    v-if="
                                      getMaxHeightForListViewScreen(
                                        date.screen_array
                                      ) < 2
                                    "
                                    >({{
                                      moment(date.show_date).format("ddd")
                                    }})</span
                                  >
                                  <div class="fs-12" v-else>
                                    ({{
                                      moment(date.show_date).format("dddd")
                                    }})
                                  </div>
                                </td>
                                <td
                                  class="cell"
                                  v-b-popover.hover.bottom="{
                                    content: `${screen.screen_name}`,
                                    html: true,
                                  }"
                                >
                                  <b> {{ screen.screen_name }}</b>
                                </td>
                                <td
                                  class="cell"
                                  colspan="2"
                                  style="cursor: pointer"
                                  :class="
                                    checkIndicator(movie)
                                      ? 'indicator-border'
                                      : ''
                                  "
                                  :style="
                                    'background-color:' + movie.backgroundColor
                                  "
                                  :title="movie.movie"
                                  v-b-popover.hover.right="{
                                    title: `<div class='fs-14 style='zoom:${zoomIndex}''> ${movie.movie}</div>`,
                                    customClass: `my-popover-class ${getPopOverClassName(
                                      movie
                                    )}  ${
                                      zoomIndex == 0.6
                                        ? 'zoom06'
                                        : zoomIndex == 0.8
                                        ? 'zoom08'
                                        : zoomIndex == 1.2
                                        ? 'zoom12'
                                        : 'zoom1'
                                    }`,
                                    content: `
                          <div class='row fs-13 style='zoom:${zoomIndex}''>
                          <div class='col-4 mr-0 pr-0'><b>Show Time<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'>${movie.ss_start_show_time ||
                            movie.start_time}-${movie.ss_end_show_time ||
                                      movie.end_time}</div>
                          <div class='col-4 mr-0 pr-0'><b>Day/Date<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'> ${moment(
                            movie.ss_actual_start_date
                          ).format('Do, MMMM (ddd)')}</div>
                          <div class='col-4 mr-0 pr-0'><b>Duration<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'>${movie.mrrdr_runtime ||
                            '-'} mins</div>
                          <div class='col-4 mr-0 pr-0'><b>Sound Format<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'>${movie.sound_format_name ||
                            '-'}</div>
                          <div class='col-4 mr-0 pr-0'><b>Occupancy<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'>${
                            movie.booked_seats
                          } Booked/ ${movie.unpaid_count} Unpaid/ ${
                                      movie.screen_total_seats
                                    } Seats</div>
                                 ${
                                   movie.ss_comment
                                     ? `
                          <div class='col-4 mr-0 pr-0'><b>Comment<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'>${movie.ss_comment}</div>
                          `
                                     : ``
                                 }
                           ${
                             movie.sales_channel &&
                             movie.sales_channel.length > 0
                               ? `
                          <div class='col-4 mr-0 pr-0 mt-3'><b>Sales Channel<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0 mt-3'>${movie.sales_channel
                            .map((x) => x.username)
                            .join(', ')}</div>
                          `
                               : `<div class='col-4 mr-0 pr-0 mt-3'><b>Sales Channel<span class='float-right mr-2'>:</span></b></div>
                              <div class='col-8 ml-0 pl-0 mt-3 text-danger'>Not Selected</div>`
                           }
                          </div>
                          `,
                                    html: true,
                                  }"
                                >
                                  {{ movie.movie }}
                                </td>
                                <td
                                  class="cell"
                                  style=""
                                  v-b-popover.hover.right="{
                                    content: `<div class='row'>
                          <div class='col-5 mr-0 pr-0'><b>Show Time - </b></div>
                          <div class='col-7 ml-0 pl-0'>${
                            movie.ss_start_show_time
                          }-${moment(movie.ss_end_show_time, 'HH:mm')
                                      .subtract(
                                        movie.cine_cleaning_time_in_mins,
                                        'm'
                                      )
                                      .format('HH:mm')}</div>
                          <div class='col-5 mr-0 pr-0'><b>Duration -</b></div>
                          <div class='col-7 ml-0 pl-0'>${convertToHrs(
                            movie.mrrdr_runtime
                          )} (${movie.mrrdr_runtime} min)</div>
                          <div class='col-5 mr-0 pr-0'><b>Cleaning -</b></div>
                          <div class='col-7 ml-0 pl-0'>${
                            movie.ss_end_show_time
                          }-${moment(movie.ss_end_show_time, 'HH:mm')
                                      .subtract(
                                        movie.cine_cleaning_time_in_mins,
                                        'm'
                                      )
                                      .format('HH:mm')} (${
                                      movie.cine_cleaning_time_in_mins
                                    } min)</div>
                          <div class='col-5 mr-0 pr-0'><b>Intermission -</b></div>
                          <div class='col-7 ml-0 pl-0'>${
                            movie.interval_time_in_mins
                          } min</div>
                          <div class='col-5 mr-0 pr-0'><b>Advertisment -</b></div>
                          <div class='col-7 ml-0 pl-0'>${
                            movie.ads_time_in_mins
                          } min</div>
                          </div>`,
                                    html: true,
                                  }"
                                >
                                  {{ movie.ss_start_show_time }} -
                                  {{ movie.ss_end_show_time }}
                                </td>
                                <td
                                  class="cell"
                                  :title="movie.d_original_name"
                                  style=""
                                >
                                  {{ movie.d_original_name }}
                                </td>

                                <td class="cell fs-13" colspan="" style="">
                                  <div
                                    v-if="movie.scheduleShowPrice.length > 0"
                                    class="rc-details"
                                    :title="getRateCardName(rc)"
                                    v-for="(rc,
                                    rcIndex) in movie.scheduleShowPrice"
                                    :key="rcIndex"
                                  >
                                    {{ getRateCardName(rc) }}
                                  </div>
                                  <div
                                    v-if="movie.scheduleShowPrice.length == 0"
                                    class="text-center"
                                  >
                                    NA
                                  </div>
                                </td>
                                <td
                                  class="cell"
                                  v-b-popover.hover.bottom="{
                                    content: `${movie.booked_seats}/ ${movie.unpaid_count} / ${movie.screen_total_seats} Seats`,
                                    html: true,
                                  }"
                                >
                                  {{
                                    `${movie.booked_seats}/ ${movie.unpaid_count} / ${movie.screen_total_seats} Seats`
                                  }}
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <td colspan="12">
                    <NoRecords />
                  </td>
                </tbody>
              </table>
            </vue-html2pdf>
          </div>

          <!---Pdf export table End-->
          <table
            class="schedule-overview-table border mb-3 p-0 listviewtable"
            border="1"
            v-if="!gridView"
          >
            <thead v-if="filteredScheduleArray.length > 0">
              <tr class="table-header-row-color">
                <th :title="'Date'">
                  <img
                    v-if="columnName != 'show_date'"
                    @click="onSortValue('show_date', 'asc')"
                    src="@/assets/img/icons/updown-white.svg"
                    class="cursor-pointer"
                    width="15px"
                    height="20px"
                  />
                  <img
                    v-else-if="isSort && isAscending"
                    @click="onSortValue('show_date', 'asc')"
                    src="@/assets/img/icons/asc-up-white.svg"
                    class="cursor-pointer"
                    width="15px"
                    height="20px"
                  />
                  <img
                    v-else
                    @click="onSortValue('show_date', 'desc')"
                    src="@/assets/img/icons/desc-down-white.svg"
                    class="cursor-pointer"
                    width="15px"
                    height="20px"
                  />
                  Date
                </th>
                <th :title="'Screen'" class="w-115">Screen</th>
                <th class="w-40 px-1">
                  <div
                    class="d-flex justify-content-center pl-2"
                    v-if="allowDeleteSchedule"
                  >
                    <b-form-checkbox
                      class="j-checkbox"
                      v-b-tooltip.hover
                      :title="'Select All'"
                      v-model="selectAllMoviesDel"
                      @change="onSelectAllDeleteMovies($event)"
                      style="padding-left: 27px"
                    />
                  </div>
                  <div
                    class="d-flex justify-content-center"
                    v-if="allowChangePlannedSchedule"
                  >
                    <b-form-checkbox
                      class="j-checkbox"
                      v-b-tooltip.hover
                      :title="'Select All'"
                      v-model="selectAllPlannedMovie"
                      @change="onSelectAllPlannedMovies($event)"
                    />
                  </div>
                </th>
                <th :title="'Movie'" colspan="2">Movie</th>
                <th :title="'Start Time'">Show Time</th>
                <th :title="'Distributor'">Distributor</th>
                <th :title="'Rate Card Details'" colspan="2">
                  Rate Card Details
                </th>
                <th :title="'Occupancy'">Occupancy</th>
              </tr>
            </thead>
            <tbody v-if="filteredScheduleArray.length > 0">
              <template v-for="date in filteredScheduleArray">
                <template v-for="(screen, screenIndex) in date.screen_array">
                  <tr
                    v-for="(movie, movieIndex) in screen.shows"
                    :key="movieIndex"
                  >
                    <td
                      v-b-popover.hover.bottom="{
                        content: `${date.show_date}`,
                        html: true,
                      }"
                    >
                      {{ date.show_date }}
                      <span
                        class="fs-12"
                        v-if="
                          getMaxHeightForListViewScreen(date.screen_array) < 2
                        "
                        >({{ moment(date.show_date).format("ddd") }})</span
                      >
                      <div class="fs-12" v-else>
                        ({{ moment(date.show_date).format("dddd") }})
                      </div>
                    </td>
                    <td
                      class="cell w-115"
                      v-b-popover.hover.bottom="{
                        content: `${screen.screen_name}`,
                        html: true,
                      }"
                    >
                      <b> {{ screen.screen_name }}</b>
                    </td>
                    <td
                      class="cell w-40 px-1"
                      style="text-align: center !important"
                    >
                      <div
                        class="d-flex justify-content-center py-1 pl-2"
                        v-if="allowDeleteSchedule"
                      >
                        <b-form-checkbox
                          class="j-checkbox p-0"
                          :disabled="
                            movie.booked_seats > 0 ||
                              movie.unpaid_count > 0 ||
                              movie.mycinema_booking_type_id > 0 ||
                              movie.ss_show_status == 13 ||
                              movie.ss_show_status == 17
                          "
                          v-b-tooltip.hover
                          :title="
                            movie.booked_seats > 0
                              ? `(${movie.booked_seats}) transaction(s) found, Please Apply for Refund.`
                              : movie.unpaid_count > 0
                              ? `(${movie.unpaid_count}) Unpaid transaction(s) found, Please Cancel Unpaid Booking.`
                              : ``
                          "
                          @change="onSelectCheckboxDeleteShow($event)"
                          :value="movie"
                          v-model="selected_delete_schedule"
                        />
                      </div>
                      <div
                        class="d-flex justify-content-center py-1"
                        v-else-if="allowChangePlannedSchedule"
                      >
                        <b-form-checkbox
                          class="j-checkbox"
                          :disabled="movie.ss_show_status !== 19"
                          @change="onSelectCheckboxOpenPlannedShow($event)"
                          :value="movie"
                          v-model="selected_planned_schedule"
                        />
                      </div>
                      <b-dropdown
                        right
                        variant="edit"
                        id="dropdown-dropright"
                        dropright
                        boundary="viewport"
                        class="align-self-end"
                        v-else
                      >
                        <b-dropdown-item
                          v-if="
                            movie.mycinema_booking_type_id != 3 &&
                              $can('read', 'Schedule')
                          "
                          @click="onClickViewSeatLayout(movie)"
                          >View Seat Layout</b-dropdown-item
                        >
                        <b-dropdown-item
                          @click="onEditMovie(movie, screen, screenIndex)"
                          v-if="
                            movie.ss_show_status != '13' &&
                              $can('update', 'Movies')
                          "
                          >Edit</b-dropdown-item
                        >
                        <b-dropdown-item
                          @click="onEditMovie(movie, screen, screenIndex)"
                          v-if="
                            movie.ss_show_status == '13' &&
                              $can('read', 'Schedules')
                          "
                          >View</b-dropdown-item
                        >
                        <b-dropdown-item
                          v-if="
                            movie.ss_show_status != '13' &&
                              movie.mycinema_booking_type_id != 3 &&
                              $can('delete', 'Schedules')
                          "
                          v-on:click="
                            onDeleteMovieModal(
                              screen,
                              movie,
                              screenIndex,
                              movieIndex
                            )
                          "
                          >Delete</b-dropdown-item
                        >

                        <b-dropdown-item
                          v-if="
                            movie.ss_show_status != '13' &&
                              movie.mycinema_booking_type_id != 3
                          "
                          v-on:click="onClickEnableDisableSchedule(movie)"
                          >{{
                            movie.is_sch_disable == "N"
                              ? "Disable Schedule"
                              : "Enable Schedule"
                          }}</b-dropdown-item
                        >
                        <b-dropdown-item
                          @click="
                            $can('read', 'Transactions')
                              ? $router.push({
                                  name: 'Transactions',
                                  query: {
                                    cinema_id: screen.cinema_id,
                                    date: moment(movie.ss_start_date).format(
                                      'YYYY-MM-DD'
                                    ),
                                    md_id: movie.md_id,
                                    ss_id: movie.ss_id,
                                  },
                                })
                              : $router.push({
                                  path: '/access-denied',
                                })
                          "
                          >View Transactions</b-dropdown-item
                        >
                        <b-dropdown-item
                          @click="
                            $can('read', 'Unpaid Booking')
                              ? $router.push({
                                  name: 'Unpaid Bookings',
                                  query: {
                                    cinema_id: screen.cinema_id,
                                    date: moment(movie.ss_start_date).format(
                                      'YYYY-MM-DD'
                                    ),
                                    md_id: movie.md_id,
                                    ss_id: movie.ss_id,
                                  },
                                })
                              : $router.push({
                                  path: '/access-denied',
                                })
                          "
                          >View Unpaid Bookings</b-dropdown-item
                        >
                        <b-dropdown-item
                          v-if="movie.mycinema_booking_type_id == 3"
                          @click="showAdmitModal(movie)"
                          >Update Admits</b-dropdown-item
                        >
                      </b-dropdown>
                    </td>
                    <td
                      class="cell"
                      colspan="2"
                      style="cursor: pointer"
                      :class="checkIndicator(movie) ? 'indicator-border' : ''"
                      :style="'background-color:' + movie.backgroundColor"
                      :title="movie.movie"
                      v-b-popover.hover.right="{
                        title: `<div class='fs-14 style='zoom:${zoomIndex}''> ${movie.movie}</div>`,
                        customClass: `my-popover-class ${getPopOverClassName(
                          movie
                        )}  ${
                          zoomIndex == 0.6
                            ? 'zoom06'
                            : zoomIndex == 0.8
                            ? 'zoom08'
                            : zoomIndex == 1.2
                            ? 'zoom12'
                            : 'zoom1'
                        }`,
                        content: `
                          <div class='row fs-13 style='zoom:${zoomIndex}''>
                          <div class='col-4 mr-0 pr-0'><b>Show Time<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'>${movie.ss_start_show_time ||
                            movie.start_time}-${movie.ss_end_show_time ||
                          movie.end_time}</div>
                          <div class='col-4 mr-0 pr-0'><b>Day/Date<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'> ${moment(
                            movie.ss_actual_start_date
                          ).format('Do, MMMM (ddd)')}</div>
                          <div class='col-4 mr-0 pr-0'><b>Duration<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'>${movie.mrrdr_runtime ||
                            '-'} mins</div>
                          <div class='col-4 mr-0 pr-0'><b>Sound Format<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'>${movie.sound_format_name ||
                            '-'}</div>
                          <div class='col-4 mr-0 pr-0'><b>Occupancy<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'>${
                            movie.booked_seats
                          } Booked/ ${movie.unpaid_count} Unpaid/ ${
                          movie.screen_total_seats
                        } Seats</div>
                                 ${
                                   movie.ss_comment
                                     ? `
                          <div class='col-4 mr-0 pr-0'><b>Comment<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'>${movie.ss_comment}</div>
                          `
                                     : ``
                                 }
                           ${
                             movie.sales_channel &&
                             movie.sales_channel.length > 0
                               ? `
                          <div class='col-4 mr-0 pr-0 mt-3'><b>Sales Channel<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0 mt-3'>${movie.sales_channel
                            .map((x) => x.username)
                            .join(', ')}</div>
                          `
                               : `<div class='col-4 mr-0 pr-0 mt-3'><b>Sales Channel<span class='float-right mr-2'>:</span></b></div>
                              <div class='col-8 ml-0 pl-0 mt-3 text-danger'>Not Selected</div>`
                           }
                          </div>
                          `,
                        html: true,
                      }"
                    >
                      {{ movie.movie }}
                    </td>
                    <td
                      class="cell"
                      v-b-popover.hover.right="{
                        content: `<div class='row'>
                          <div class='col-5 mr-0 pr-0'><b>Show Time - </b></div>
                          <div class='col-7 ml-0 pl-0'>${
                            movie.ss_start_show_time
                          }-${moment(movie.ss_end_show_time, 'HH:mm')
                          .subtract(movie.cine_cleaning_time_in_mins, 'm')
                          .format('HH:mm')}</div>
                          <div class='col-5 mr-0 pr-0'><b>Duration -</b></div>
                          <div class='col-7 ml-0 pl-0'>${convertToHrs(
                            movie.mrrdr_runtime
                          )} (${movie.mrrdr_runtime} min)</div>
                          <div class='col-5 mr-0 pr-0'><b>Cleaning -</b></div>
                          <div class='col-7 ml-0 pl-0'>${
                            movie.ss_end_show_time
                          }-${moment(movie.ss_end_show_time, 'HH:mm')
                          .subtract(movie.cine_cleaning_time_in_mins, 'm')
                          .format('HH:mm')} (${
                          movie.cine_cleaning_time_in_mins
                        } min)</div>
                          <div class='col-5 mr-0 pr-0'><b>Intermission -</b></div>
                          <div class='col-7 ml-0 pl-0'>${
                            movie.interval_time_in_mins
                          } min</div>
                          <div class='col-5 mr-0 pr-0'><b>Advertisment -</b></div>
                          <div class='col-7 ml-0 pl-0'>${
                            movie.ads_time_in_mins
                          } min</div>
                          </div>`,
                        html: true,
                      }"
                    >
                      {{ movie.ss_start_show_time }} -
                      {{ movie.ss_end_show_time }}
                    </td>
                    <td class="cell" :title="movie.d_original_name">
                      {{ movie.d_original_name }}
                    </td>

                    <td class="cell fs-13" colspan="2">
                      <div
                        v-if="movie.scheduleShowPrice.length > 0"
                        class="rc-details"
                        :title="getRateCardName(rc)"
                        v-for="(rc, rcIndex) in movie.scheduleShowPrice"
                        :key="rcIndex"
                      >
                        {{ getRateCardName(rc) }}
                      </div>
                      <div
                        v-if="movie.scheduleShowPrice.length == 0"
                        class="text-center"
                      >
                        NA
                      </div>
                    </td>
                    <td
                      class="cell"
                      v-b-popover.hover.bottom="{
                        content: `${movie.booked_seats}/ ${movie.unpaid_count} / ${movie.screen_total_seats} Seats`,
                        html: true,
                      }"
                    >
                      {{
                        `${movie.booked_seats}/ ${movie.unpaid_count} / ${movie.screen_total_seats} Seats`
                      }}
                    </td>
                  </tr>
                </template>
              </template>
            </tbody>
            <tbody v-else>
              <td colspan="12">
                <NoRecords />
              </td>
            </tbody>
          </table>
          <div class="">
            <div class="d-flex justify-content-end align-items-center">
              <div
                class="color-coding row mx-auto ml-1"
                style="margin-left: 0px !important"
                v-if="typeList.length > 0"
              >
                <div
                  class="pr-2"
                  v-for="(type, typeIndex) in typeList"
                  :key="typeIndex"
                >
                  <div class="d-flex">
                    <div class="col-1">
                      <div
                        class="color-box"
                        :style="'background-color:' + type.color"
                      ></div>
                    </div>
                    <div class="col-10 color-combination">
                      {{ type.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="viewSeatLayoutModal"
      ref="viewSeatLayoutModal"
      title="Seat Layout"
      hide-footer
      show
    >
      <div>
        <div class="row mx-0 pt-3 justify-content-between">
          <div class="grid-seat-buttons">
            <div class="">
              <div class="pos-seat regular-seat bg-blue"></div>
              <p>Regular {{ $tc("seat", 1) }}</p>
            </div>

            <div>
              <div class="pos-seat wheelchair"></div>
              <p>{{ $t("wheelchair") }}</p>
            </div>

            <div>
              <div class="pos-seat vip-seat bg-blue"></div>
              <p>VIP {{ $tc("seat", 1) }}</p>
            </div>

            <div>
              <div class="pos-seat pointofsale-seat bg-blue"></div>
              <p>{{ $t("onlyPos") }}</p>
            </div>

            <div class="mx-1">
              <div
                class="pos-seat my-0 sofa-seat seat-fixed-width mx-auto bg-blue"
              ></div>
              <small>{{ $tc("Sofa", 1) }}</small>
            </div>

            <div class="">
              <div class="pos-seat recliner-seat bg-blue"></div>
              <p>{{ $t("recliner") }} {{ $tc("seat", 1) }}</p>
            </div>

            <div class="">
              <div
                class="pos-seat my-0 block-seat seat-fixed-width mx-auto"
              ></div>
              <p>{{ $tc("blockSeat", 1) }}</p>
            </div>

            <div class="">
              <div class="pos-seat broken-seat bg-blue"></div>
              <p>{{ $t("broken") }} {{ $tc("seat", 1) }}</p>
            </div>

            <div class="">
              <div class="pos-seat taken"></div>
              <p>{{ $t("taken") }}</p>
            </div>

            <div>
              <div class="pos-seat reserved-seat"></div>
              <p>{{ $t("reserved") }} {{ $tc("seat", 1) }}</p>
            </div>
          </div>
        </div>

        <div :class="['pos-seatlayout']">
          <table v-for="(seat, seatIndex) in seatType" :key="seatIndex">
            <tr v-if="seatIndex === 0">
              <td colspan="30">
                <div class="relative pb-3">
                  <img
                    src="@/assets/img/pos/pos-screen.png"
                    class="img-fluid w-100"
                  />
                  <span class="eyes-text">{{ $t("screen_title") }}</span>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="22">
                <div class="pos-seat-class">
                  {{ seat.seatType }}
                  <strong
                    >({{ seat.seat_price }}
                    {{ currencyData.curr_code }})</strong
                  >
                </div>
              </td>
            </tr>

            <tr
              v-for="(seatRow, seatRowIndex) in seat.seatsFinal"
              :key="seatRowIndex"
            >
              <td
                v-for="(singleSeat, singleSeatIndex) in seatRow"
                :key="'index' + singleSeatIndex"
                :class="
                  singleSeat.sst_seat_type.toLowerCase() == 'sofa'
                    ? 'lounger-container'
                    : ''
                "
              >
                <div v-if="singleSeat.srt_id == 2" class="pos-seatNumber"></div>
                <div v-else class="pos-seatNumber">
                  {{ singleSeat.sl_seat_name }}
                </div>
                <div
                  v-if="singleSeat.seat_reserve_type_id == 5"
                  class="pos-seat bg-blue vip-seat cursor-pointer"
                  disabled
                ></div>
                <div
                  v-else
                  disabled
                  class="pos-seat cursor-pointer"
                  :class="[
                    singleSeat.selectStatus == true
                      ? 'your-selection'
                      : singleSeat.isVipReserved
                      ? 'reserved-seat taken pointer-events'
                      : singleSeat.seat_reserve_type_id == 1
                      ? 'bg-blue regular-seat'
                      : singleSeat.seat_reserve_type_id == 3
                      ? 'bg-blue wheelchair'
                      : singleSeat.seat_reserve_type_id == 6
                      ? 'bg-blue love-seat'
                      : singleSeat.seat_reserve_type_id == 8
                      ? 'taken pointer-events'
                      : singleSeat.seat_reserve_type_id == 10
                      ? 'bg-blue sofa-seat'
                      : singleSeat.seat_reserve_type_id == 9
                      ? 'bg-blue pointofsale-seat'
                      : singleSeat.seat_reserve_type_id == 10
                      ? 'bg-blue normal-seat'
                      : singleSeat.seat_reserve_type_id == 11
                      ? 'bg-blue recliner-seat'
                      : singleSeat.seat_reserve_type_id == 12
                      ? 'new-block-seat'
                      : singleSeat.seat_reserve_type_id == 13
                      ? 'bg-blue pointer-events broken-seat'
                      : 'normal-seat',
                    singleSeat.sst_seat_type.toLowerCase() == 'sofa'
                      ? 'lounger'
                      : '',
                  ]"
                ></div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="updateMovie"
      ref="updateMovie"
      :title="
        movieSelected.hasOwnProperty('ss_show_status')
          ? movieSelected.ss_show_status == '13'
            ? `View Details`
            : `Update Movie`
          : `Update Movie`
      "
      hide-footer
      size="lg"
      show
    >
      <div>
        <div class="row mx-0" style="font-size: 13px">
          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Movie Name:</div>
              <div class="col-8">
                <strong>{{
                  movieSelected.movie || movieSelected.movie_title
                }}</strong>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row hh">
              <div class="col-4">Language:</div>
              <div class="col-8">
                <strong>{{ movieSelected.lang_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Sound Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.sound_format_name || "-" }}</strong>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.mf_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Movie Length</div>
              <div class="col-8">
                <strong>{{ convertToHrs(movieSelected.mrrdr_runtime) }}</strong>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Total Run Time</div>
              <div class="col-8">
                <strong>{{ convertToHrs(movieSelected.lengthMinutes) }}</strong>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Start Time</div>
              <div class="col-8">
                <div
                  class="custom-timepicker"
                  v-if="movieSelected.ss_show_status != 13"
                  @click="checkStartTimeChageAllowed(movieSelected)"
                >
                  <vue-timepicker
                    manual-input
                    v-model="movieSelected.start_time"
                    :disabled="checkStartTimeChageAllowed(movieSelected, false)"
                    id="showtime"
                    name="showtime"
                    format="HH:mm"
                    class="time_picker"
                    input-width="100%"
                    auto-scroll
                    lazy
                    :hide-clear-button="true"
                    v-validate="'required'"
                    @change="onChangeShowStartTime($event)"
                  ></vue-timepicker>
                </div>
                <div class="" v-else>
                  {{ movieSelected.ss_start_show_time }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">End Time</div>
              <div class="col-8">
                <strong> {{ movieSelected.ss_end_show_time }}</strong>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Interval Time (Mins)</div>
              <div class="col-8">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="movieSelected.interval_time_in_mins"
                      type="text"
                      :disabled="movieSelected.ss_show_status == 13"
                      name="intervaltime"
                      id="intervaltime"
                      v-validate="'required|numeric'"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Cleaning Time (Mins)</div>
              <div class="col-8">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="movieSelected.cleaning_time_in_mins"
                      type="text"
                      :disabled="movieSelected.ss_show_status == 13"
                      name="cleaning_time_in_mins"
                      id="cleaning_time_in_mins"
                      v-validate="'required|numeric'"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Advertisement Time (Mins)</div>
              <div class="col-8">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="movieSelected.ads_time_in_mins"
                      type="text"
                      :disabled="movieSelected.ss_show_status == 13"
                      name="settingadstime"
                      id="settingadstime"
                      v-validate="'required|numeric'"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-6 border-bottom py-2"
            v-if="movieSelected.ss_show_status != 13"
          >
            <div class="row">
              <div class="col-4">Schedule Type</div>
              <div
                class="col-8"
                @click="checkStartTimeChageAllowed(movieSelected)"
              >
                <multiselect
                  :disabled="checkStartTimeChageAllowed(movieSelected, false)"
                  v-model="movieSelected.selectedShowStatus"
                  track-by="status_id"
                  label="type"
                  @select="onSelectStatus($event, $event)"
                  :options="changeStatusArray"
                  :multiple="false"
                ></multiselect>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-2">
                Comment <span class="text-truncate fs-12">(optional)</span>
              </div>
              <div class="col-10">
                <div class="input-material-textarea">
                  <textarea
                    rows="2"
                    placeholder="."
                    type="text"
                    :disabled="movieSelected.ss_show_status == 13"
                    v-model="movieSelected.ss_comment"
                    name="ss_comment"
                    id="ss_comment"
                    style="
                      border-radius: 10px;
                      border-color: #d3d3d3;
                      resize: none;
                    "
                  />
                  <label>Comment</label>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-2">Sales Channel</div>
              <div class="col-10">
                <multiselect
                  v-model="movieSelected.sales_channel"
                  :disabled="movieSelected.ss_show_status == 13"
                  track-by="user_id"
                  label="username"
                  @select="onSelectSalesChannel($event, movieSelected)"
                  @remove="onRemoveSalesChannel($event, movieSelected)"
                  :options="aggregatorUsersList"
                  :multiple="true"
                ></multiselect>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-2">Add on charges</div>
              <div class="col-10">
                <multiselect
                  v-model="movieSelected.AddonsCharges"
                  :disabled="movieSelected.ss_show_status == 13"
                  track-by="marc_id"
                  id="addonCharges"
                  ref="addonCharges"
                  label="addons_name"
                  :options="AddonChargesArray"
                  :multiple="true"
                >
                  <template slot="option" slot-scope="props"
                    ><span>
                      {{ props.option.addons_name }}-{{
                        props.option.add_ons_price
                      }}&nbsp;{{
                        props.option.is_percentage == "Y"
                          ? "%"
                          : currencyData.curr_code
                      }}
                    </span>
                  </template>
                  <template slot="tag" slot-scope="props">
                    <span class="multiselect__tag">
                      <span
                        >{{ props.option.addons_name }}-{{
                          props.option.add_ons_price
                        }}&nbsp;{{
                          props.option.is_percentage == "Y"
                            ? "%"
                            : currencyData.curr_code
                        }}</span
                      >
                      <i
                        aria-hidden="true"
                        tabindex="1"
                        @keydown.enter.prevent="removeElement(props.option)"
                        @mousedown.prevent="removeElement(props.option)"
                        class="multiselect__tag-icon"
                      ></i>
                    </span>
                  </template>
                </multiselect>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-2">Rate Cards</div>
              <div class="col-10">
                <div class="row">
                  <div
                    class="col-4"
                    v-for="(schPrice,
                    schPriceIndex) in movieSelected.scheduleShowPrice"
                    :key="schPriceIndex"
                  >
                    <div
                      class="
                        dropdown-curve-container
                        placeholder-red
                        dropDownElipsis
                      "
                    >
                      <label class="shift-up">{{
                        schPrice.sst_seat_type
                      }}</label>
                      <multiselect
                        v-model="schPrice.selectedRateCard"
                        :disabled="movieSelected.ss_show_status == 13"
                        :title="schPrice.selectedRateCard.rc_g_name"
                        track-by="rc_g_id"
                        label="rc_g_name"
                        :placeholder="'No Rate Card Selected'"
                        @select="
                          onSelectRateCardFromEdit(
                            $event,
                            movieSelected,
                            schPriceIndex
                          )
                        "
                        :allow-empty="true"
                        :options="
                          filteredRateCardList(
                            selectedScreen,
                            schPrice,
                            RatecardsList
                          )
                        "
                        :multiple="false"
                        deselect-label=""
                      >
                      </multiselect>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-12 border-bottom py-2"
            v-if="movieSelected.mycinema_booking_type_id === 3"
          >
            <h6>Private Show Details:</h6>

            <table class="table border customerDetailsTable" border>
              <tbody>
                <tr>
                  <td><strong>Customer Name: </strong></td>
                  <td>{{ movieSelected.customer_name }}</td>
                </tr>
                <tr>
                  <td><strong>Customer Email: </strong></td>
                  <td>{{ movieSelected.cust_email }}</td>
                </tr>
                <tr>
                  <td><strong>Customer Mobile: </strong></td>
                  <td>{{ movieSelected.customer_mobile }}</td>
                </tr>
                <tr>
                  <td><strong>Is Guest User: </strong></td>
                  <td>{{ movieSelected.is_guest_user }}</td>
                </tr>
                <tr>
                  <td><strong>Special Request: </strong></td>
                  <td>
                    {{
                      movieSelected.special_request
                        ? movieSelected.special_request
                        : "None"
                    }}
                  </td>
                </tr>
                <template v-if="movieSelected.privateShowBookingDetails">
                  <tr>
                    <td><strong>Booking Code: </strong></td>
                    <td>
                      {{
                        movieSelected.privateShowBookingDetails.sb_booking_code
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Transaction Date and Time: </strong></td>
                    <td>
                      {{
                        moment(
                          movieSelected.privateShowBookingDetails
                            .sb_booking_date_time
                        ).format("DD-MM-YYYY HH:mm")
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Total Amount: </strong></td>
                    <td>
                      {{
                        currFormat(
                          movieSelected.privateShowBookingDetails
                            .sb_total_amount
                        )
                      }}
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div
            class="col-12 pt-3 text-center"
            v-if="movieSelected.ss_show_status != 13"
          >
            <button v-on:click="onUpdate()" class="btn-blue">Update</button>
            <button
              @click.prevent.stop="$bvModal.hide('updateMovie')"
              class="btn-blue"
            >
              Cancel
            </button>
          </div>
          <div class="col-12 pt-3 text-center" v-else>
            <button
              @click.prevent.stop="$bvModal.hide('updateMovie')"
              class="btn-blue"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="_updateMovie"
      ref="_updateMovie"
      title="Update Movie"
      hide-footer
      show
    >
      <div>
        <div class="row mx-0">
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Movie Name:</div>
              <div class="col-8">
                <strong>{{
                  movieSelected.movie || movieSelected.movie_title
                }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row hh">
              <div class="col-4">Language:</div>
              <div class="col-8">
                <strong>{{ movieSelected.lang_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Sound Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.sound_format_name || "-" }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.mf_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Movie Length</div>
              <div class="col-8">
                <strong>{{ convertToHrs(movieSelected.mrrdr_runtime) }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Total Run Time</div>
              <div class="col-8">
                <strong>{{ convertToHrs(movieSelected.lengthMinutes) }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Start Time</div>
              <div class="col-8">
                <div class="custom-timepicker">
                  <vue-timepicker
                    manual-input
                    v-model="movieSelected.startTime2"
                    id="showtime"
                    name="showtime"
                    format="HH:mm"
                    class="time_picker"
                    input-width="100%"
                    auto-scroll
                    lazy
                    v-validate="'required'"
                    @change="onChangeShowStartTime($event)"
                  ></vue-timepicker>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">End Time</div>
              <div class="col-8">
                <strong> {{ movieSelected.ss_end_show_time }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Interval Time</div>
              <div class="col-6">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="movieSelected.interval_time_in_mins"
                      type="text"
                      name="intervaltime"
                      id="intervaltime"
                      v-validate="'required|numeric'"
                    />
                  </div>
                </div>
              </div>
              <div class="col-2">
                <strong>Mins</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Cleaning Time</div>
              <div class="col-6">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="movieSelected.cleaning_time_in_mins"
                      type="text"
                      name="cleaning_time_in_mins"
                      id="cleaning_time_in_mins"
                      v-validate="'required|numeric'"
                    />
                  </div>
                </div>
              </div>
              <div class="col-2">
                <strong>Mins</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Advertisement Time</div>
              <div class="col-6">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="movieSelected.ads_time_in_mins"
                      type="text"
                      name="settingadstime"
                      id="settingadstime"
                      v-validate="'required|numeric'"
                    />
                  </div>
                </div>
              </div>
              <div class="col-2">
                <strong>Mins</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-3">
            <div class="row">
              <div class="col-4">Artwork Image</div>
              <div class="col-6">
                <div class="d-flex align-items-center">
                  <label
                    class="material-file-upload"
                    @click.prevent.stop="setModalData()"
                  >
                    <div
                      class="label"
                      v-bind:class="{
                        'shift-up': movieSelected.sch_artwork_url,
                      }"
                    >
                      {{ "Artwork Image" }}
                    </div>
                    <div class="uploaded-file-name">
                      <div class="text-truncate pt-2">
                        {{ movieSelected.sch_artwork_url }}
                      </div>
                    </div>
                  </label>
                  <!-- <Tooltip :title="`Special Schedule Artwork`" /> -->
                </div>
              </div>
              <div class="col-2 align-self-center pl-3">
                <img
                  width="40"
                  height="40"
                  class="rounded c-pointer img-preview"
                  @click="openImageModal()"
                  :src="_GetImagePath(movieSelected.sch_artwork_url)"
                  v-if="movieSelected.sch_artwork_url"
                />
                <img
                  v-else
                  width="35"
                  height="35"
                  class="rounded"
                  alt="Empty Image"
                  src="@/assets/img/icons/empty-image.svg"
                />
              </div>
            </div>
          </div>
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Sales Channel</div>
              <div class="col-8">
                <multiselect
                  v-model="movieSelected.sales_channel"
                  track-by="user_id"
                  label="username"
                  @select="onSelectSalesChannel($event, movieSelected)"
                  @remove="onRemoveSalesChannel($event, movieSelected)"
                  :options="aggregatorUsersList"
                  :multiple="true"
                ></multiselect>
              </div>
            </div>
          </div>
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">
                Comment <span class="text-truncate fs-12">(optional)</span>
              </div>
              <div class="col-8">
                <div class="input-material">
                  <input
                    placeholder="."
                    type="text"
                    :disabled="movieSelected.ss_show_status == 13"
                    v-model="movieSelected.ss_comment"
                    name="ss_comment"
                    id="ss_comment"
                  />
                  <label>Comment</label>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-12 border-bottom py-2"
            v-if="movieSelected.mycinema_booking_type_id === 3"
          >
            <h6>Private Show Details:</h6>
            <p>
              <strong>Customer Name: </strong
              ><span>{{ movieSelected.customer_name }}</span>
            </p>
            <p>
              <strong>Customer Email: </strong
              ><span>{{ movieSelected.cust_email }}</span>
            </p>
            <p>
              <strong>Customer Mobile: </strong
              ><span>{{ movieSelected.customer_mobile }}</span>
            </p>
            <p>
              <strong>Is Guest User: </strong
              ><span>{{ movieSelected.is_guest_user }}</span>
            </p>
            <p>
              <strong>Special Request: </strong
              ><span>{{
                movieSelected.special_request
                  ? movieSelected.special_request
                  : "None"
              }}</span>
            </p>

            <div v-if="movieSelected.privateShowBookingDetails">
              <p>
                <strong>Booking Code: </strong
                ><span>{{
                  movieSelected.privateShowBookingDetails.sb_booking_code
                }}</span>
              </p>

              <p>
                <strong>Transaction Date and Time: </strong
                ><span>{{
                  moment(
                    movieSelected.privateShowBookingDetails.sb_booking_date_time
                  ).format("DD-MM-YYYY HH:mm")
                }}</span>
              </p>

              <p>
                <strong>Total Amount: </strong
                ><span>{{
                  currFormat(
                    movieSelected.privateShowBookingDetails.sb_total_amount
                  )
                }}</span>
              </p>
            </div>
          </div>

          <div class="col-12 pt-3 text-center">
            <button v-on:click="onUpdate()" class="btn-blue">Update</button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="saveMovie"
      ref="ratecardmodal"
      :title="
        movieSelected.hasOwnProperty('ss_show_status')
          ? movieSelected.ss_show_status == '13'
            ? `View Details`
            : `Update Price`
          : `Update Price`
      "
      hide-footer
      show
    >
      <div>
        <div class="row mx-0">
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Movie Name:</div>
              <div class="col-8">
                <strong>{{
                  movieSelected.movie || movieSelected.movie_title
                }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row hh">
              <div class="col-4">Language:</div>
              <div class="col-8">
                <strong>{{ movieSelected.lang_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.mf_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Sound Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.sound_format_name || "-" }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Showtime:</div>
              <div class="col-8">
                <strong>{{ movieSelected.ss_start_show_time }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Movie Length:</div>
              <div class="col-8">
                <strong>{{ convertToHrs(movieSelected.mrrdr_runtime) }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Total Runtime:</div>
              <div class="col-8">
                <strong>{{ convertToHrs(movieSelected.lengthMinutes) }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">End Time:</div>
              <div class="col-8">
                <strong>{{ movieSelected.ss_end_show_time }}</strong>
              </div>
            </div>
          </div>
          <!-- CLEANING,ADV, INTERVAL TIME -->
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Interval Time</div>
              <div class="col-6">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="movieSelected.interval_time_in_mins"
                      type="text"
                      name="intervaltime"
                      id="intervaltime"
                      :disabled="movieSelected.ss_show_status == '13'"
                      v-validate="'required|numeric'"
                    />
                  </div>
                </div>
              </div>
              <div class="col-2">
                <strong>Mins</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Cleaning Time</div>
              <div class="col-6">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="movieSelected.cleaning_time_in_mins"
                      type="text"
                      name="cleaning_time_in_mins"
                      id="cleaning_time_in_mins"
                      v-validate="'required|numeric'"
                      :disabled="movieSelected.ss_show_status == '13'"
                    />
                  </div>
                </div>
              </div>
              <div class="col-2">
                <strong>Mins</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Advertisement Time</div>
              <div class="col-6">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="movieSelected.ads_time_in_mins"
                      type="text"
                      name="settingadstime"
                      id="settingadstime"
                      :disabled="movieSelected.ss_show_status == '13'"
                      v-validate="'required|numeric'"
                    />
                  </div>
                </div>
              </div>
              <div class="col-2">
                <strong>Mins</strong>
              </div>
            </div>
          </div>
          <!-- CLEANING,ADV, INTERVAL TIME -->
          <div
            v-for="(SeatTypes, SeatTypesIndex) in selectedScreenSeatTypes"
            :key="SeatTypesIndex"
            class="col-12 border-bottom py-2"
          >
            <div class="row">
              <div class="col-4">
                {{
                  movieSelected.scheduleShowPrice[SeatTypesIndex].sst_seat_type
                }}
              </div>
              <div class="col-8 d-flex align-items-center">
                <b-dropdown
                  class="w-100"
                  variant="dropdown-curve"
                  :text="
                    movieSelected.scheduleShowPrice[SeatTypesIndex].rc_name
                  "
                >
                  <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      placeholder="Search Rate Card"
                      class="form-control form-control-sm"
                      v-on:keyup="
                        onSearchRateCard(
                          selectedScreenIndex,
                          selectedMovieIndex,
                          SeatTypesIndex
                        )
                      "
                      v-on:keydown="
                        onSearchRateCard(
                          selectedScreenIndex,
                          selectedMovieIndex,
                          SeatTypesIndex
                        )
                      "
                      v-model="
                        movieSelected.scheduleShowPrice[SeatTypesIndex]
                          .searchRateCard
                      "
                    />
                  </div>
                  <b-dropdown-item
                    v-for="(Ratecard, RatecardIndex) in RatecardsList"
                    :key="RatecardIndex"
                    v-on:click="
                      onChangeRateCard(Ratecard, SeatTypes, SeatTypesIndex)
                    "
                    >{{ Ratecard.rc_g_name }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>
          </div>

          <div
            class="col-12 pt-3 text-center"
            v-if="movieSelected.ss_show_status != 13"
          >
            <button v-on:click="onClickupdateRateCard()" class="btn-blue">
              Update
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="deleteMovieModal"
      ref="deleteMovieModal"
      title="Delete Movie"
      hide-footer
      show
    >
      <div>
        <div class="row mx-0">
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Movie Name:</div>
              <div class="col-8">
                <strong>{{ movieSelected.movie_title }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row hh">
              <div class="col-4">Language:</div>
              <div class="col-8">
                <strong>{{ movieSelected.lang_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.mf_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Sound Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.sound_format_name || "-" }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Run Time</div>
              <div class="col-8">
                <strong>{{ convertToHrs(movieSelected.lengthMinutes) }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Start Time</div>
              <div class="col-8">
                <strong>{{ movieSelected.ss_start_show_time }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">End Time</div>
              <div class="col-8">
                <strong>{{ movieSelected.ss_end_show_time }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Interval Time</div>
              <div class="col-8">
                <strong
                  >{{ CinemasSettings.cine_interval_time_in_mins }} Mins</strong
                >
              </div>
            </div>
          </div>
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Cleaning Time</div>
              <div class="col-8">
                <strong
                  >{{ CinemasSettings.cine_cleaning_time_in_mins }} Mins</strong
                >
              </div>
            </div>
          </div>
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-12">
                <div class="input-material">
                  <input
                    placeholder="."
                    type="text"
                    v-model="movieSelected.delete_reason"
                    v-validate="{ required: 'required' }"
                    name="delete_reason"
                    id="delete_reason"
                  />
                  <label>Reason For Deletion</label>
                </div>
              </div>
            </div>
            <p class="error_message">
              <span v-if="deleteSubmit && errors.has('delete_reason')">{{
                errors.first("delete_reason")
              }}</span>
            </p>
          </div>
          <div class="col-12 pt-3 text-center">
            <button
              v-on:click="
                onDeleteMovie(
                  selectedScreen,
                  movieSelected,
                  selectedScreenIndex,
                  selectedMovieIndex
                )
              "
              class="btn-blue"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="enableDisableSchedule"
      ref="enableDisableSchedule"
      title="Confirmation"
      hide-footer
      hide-header
      no-close-on-backdrop
    >
      <div class="text-center pb-1">
        <p class="fs-16 my-4">
          Are you sure you want to
          {{ scheduleStatusType == 1 ? "disable" : "enable" }} schedule?
        </p>

        <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('enableDisableSchedule')"
        >
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-blue px-4 fs-14"
          @click.prevent.stop="handleEnableDisableSch(selectedSchedule)"
        >
          {{ scheduleStatusType == 1 ? "Disable" : "Enable" }}
        </button>
      </div>
    </b-modal>

    <b-modal id="admits" ref="admits" centered hide-footer hide-header>
      <div class="text-center py-4">
        <h5 class="font-weight-bold">Update Admits</h5>

        <div class="d-flex justify-content-center align-items-stretch my-4">
          <button
            class="plus-minus-btn h-50 w-60"
            @click="handleAdmitChange('sub')"
          >
            -
          </button>
          <input
            type="number"
            v-model="currentAdmits"
            :min="0"
            class="flex-grow-1 form-control h-50"
            @change="handleInputChange"
          />
          <button
            class="plus-minus-btn h-50 w-60"
            @click="handleAdmitChange('add')"
          >
            +
          </button>
        </div>
        <div class="text-muted">Total Admits: {{ totalAdmits }}</div>

        <button @click="onSubmitAdmits()" class="btn btn-primary">
          Confirm
        </button>
      </div>
    </b-modal>

    <b-modal
      id="open_muliple_planned_confirmation"
      title="Open Planned Schedules"
      ref="open_muliple_planned_confirmation"
      hide-footer
      @hide="handleCloseModal"
      no-close-on-backdrop
    >
      <div class="text-center pb-1">
        <p class="fs-16 mb-4">
          Are you sure you want to Open ({{ selected_planned_schedule_length }})
          Planned Schedules?
        </p>

        <button
          class="btn-outline-blue"
          @click.prevent.stop="
            $bvModal.hide('open_muliple_planned_confirmation')
          "
        >
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-delete px-4 fs-14"
          @click.prevent.stop="scheduleplannedSchedules()"
        >
          Confirm ({{ selected_planned_schedule_length }})
        </button>
      </div>
    </b-modal>

    <b-modal
      id="delete_muliple_confirmation"
      title="Delete Multiple Schedules?"
      ref="delete_muliple_confirmation"
      hide-footer
      @hide="handleCloseModal"
      no-close-on-backdrop
    >
      <div class="text-center pb-1">
        <p class="fs-16 mb-4">
          Are you sure you want to Delete ({{ selected_schedule_length }})
          Schedules?
        </p>

        <div class="col-12 py-2 mb-4">
          <div class="row mx-auto">
            <div class="col-12">
              <div class="input-material">
                <input
                  placeholder="."
                  type="text"
                  v-model="multi_schedule_delete_reason"
                  v-validate="{ required: 'required' }"
                  name="delete_reason"
                  id="delete_reason"
                />
                <label>Reason For Deletion (Required)</label>
              </div>
            </div>
          </div>
        </div>

        <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('delete_muliple_confirmation')"
        >
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          :disabled="!multi_schedule_delete_reason || disableDeleteBtn"
          :class="
            !multi_schedule_delete_reason || disableDeleteBtn
              ? 'disDeleteBtn'
              : ''
          "
          class="btn btn-delete px-4 fs-14"
          @click.prevent.stop="handleDeleteMultipleSchedule()"
        >
          Delete ({{ selected_schedule_length }})
        </button>
      </div>
    </b-modal>
    <b-pagination
      v-if="!gridView"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
  import momentT from "moment-timezone";

  import MasterService from "@/services/MasterService";
  import scheduleService from "@/services/scheduleService";
  import RefundService from "@/services/RefundService";
  import moment, { min } from "moment";
  import CinemasService from "@/services/CinemasService";
  import { BASEURL } from "@/config/index.js";
  import _ from "lodash";
  import DatePicker from "vue2-datepicker";
  import VueTimepicker from "vue2-timepicker";
  import "vue2-timepicker/dist/VueTimepicker.css";
  import PosService from "@/services/PosService";
  import { groupBy } from "lodash";
  import VueCropper from "vue-cropperjs";
  import "cropperjs/dist/cropper.css";
  import { mapGetters } from "vuex";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import ImageGallery from "@/components/Pages/ImageGallery/imageGalleryModal";
  import { createQueryString } from "@/services/ApiHelper";
  import VueHtml2pdf from "vue-html2pdf";
  import { CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";


  export default {
    components: {
      DatePicker,
      VueTimepicker,
      ImageGallery,
      VueCropper,
      NoRecords,
      VueHtml2pdf,
    },
    data() {
      return {
        htmlToPdfOptions: {
          filename: "Schedule Overview",
          margin: 2,
          image: {
            type: "jpeg",
            quality: 2,
          },
          html2canvas: {
            scale: 1,
            useCORS: true,
          },
          jsPDF: {
            format: "a2",
            orientation: "landscape",
          },
        },
        perPage: 20,
        currentPage: 1,
        searchValue: null,
        orderBy: null,
        columnName: null,
        rows: 0,
        selectedvalue: "20",
        viewingnumbers: [
          { name: "All", id: 1 },
          { name: "10", id: 2 },
          { name: "20", id: 3 },
          { name: "30", id: 3 },
          { name: "40", id: 4 },
          { name: "50", id: 5 },
        ],
        AddonChargesArray: [],
        isChanged: false,
        aggregatorUsersList: [],
        allowChangePlannedSchedule: false,
        selected_planned_schedule: [],
        selectAllPlannedMovie: false,
        isSort: false,
        isAscending: true,
        orderby: "",
        columnName: "",
        selectAllMoviesDel: false,
        disableDeleteBtn: false,
        multi_schedule_delete_reason: "",
        deleteMultipleSubmit: false,
        selected_delete_schedule: [],
        allowDeleteSchedule: false,
        gridView: false,
        selectedScreendd: "",
        selectedCinema: "",
        status: 1619,
        cinemaId: null,
        screenId: null,
        screenList: [],
        ScreenArray: [],
        scheduleArray: [],
        selectedScreen: "",
        start_date: moment().format(),
        end_date: moment()
          .add(7, "d")
          .format(),
        showTypeFilter: { type: "Schedule/Planned", status_id: 1619 },
        disabledDatesFrom: {
          to: new Date(Date.now() - 864000),
        },
        // disabledDatesTo: {
        //   from: new Date(moment().add(7, "d").format()),
        // },
        changeStatusArray: [
          { type: "Schedule", status_id: 16 },
          { type: "Planned", status_id: 19 },
        ],
        scheduleStatusArray: [
          { type: "Schedule/Planned", status_id: 1619 },
          { type: "Schedule Only", status_id: 16 },
          { type: "Planned Only", status_id: 19 },
          { type: "Deleted", status_id: 17 },
          { type: "Event", status_id: 1600 },
          { type: "Private Shows", status_id: 3 },
          { type: "On Demand", status_id: 2 },
        ],
        selectedSchedule: null,
        scheduleStatusType: null,
        seatLayoutData: [],
        showModal: false,
        screenObj: null,
        currencyData: null,
        deletedScheduleDetails: null,
        filmTitle: "",
        btenable: false,
        deleteFlag: false,
        submitted: true,
        disabledDates: {
          to: new Date(Date.now() - 8640000),
        },

        timeZone: {
          tz_name: "",
          tz_utc_offset: "",
        },

        duplicate: {
          cine_id: null,
          ss_start_date: "",
          ss_end_date: "",
        },
        deleteSubmit: false,
        searchRateCard: "",
        topValue: 0,
        intervalsArray: [],
        isRoleID: true,
        Cinemas: [],
        baseURL: BASEURL,
        movieSelected: {
          delete_reason: "Please Enter Reason for Deletion",
          lang_name: "Spanish",
          md_id: 12,
          md_thumbnail_url: "/uploads/movies/1566220586425-dummy.jpg",
          mf_name: "3D",
          movie_id: 7,
          movie_is_active: "Y",
          movie_title: "Frozen 2",
          mrrdr_runtime: 132,
          interval_time_in_mins: "",
          cleaning_time_in_mins: "",
          ads_time_in_mins: "",
          start_time: "",
          isNewSchedule: false,
        },
        selectedMovieIndex: null,
        selectedScreenIndex: null,
        //
        selectedScreen: {},
        cinemasSelected: [],
        cinemaSelectedPlaceHolder: "Select Cinema",
        selectedCinema: "",
        selectedDuplicateCinema: "",
        lists: {
          movies: [],
          cinemas: {
            list: [],
            selectedCinema: {
              cine_name: "",
            },
          },
          screens: [],
        },
        selectedNewDate: "",
        initialSelectedScreen: "Screen 2",
        silderOne: {
          infinite: false,
          dots: false,
          arrows: true,
          slidesToShow: 7,
        },
        silderTwo: {
          infinite: false,
          dots: false,
          arrows: true,
          slidesToShow: 5,
        },
        dropLocation: {
          screen: "",
          hour: "",
          minute: "",
        },
        draggedObject: {
          screen: "",
          length: "",
          oldStart: "",
          newStart: "",
          movie: "",
        },
        selectedMoviesInScreens: [],
        selectedMoviesInScreensFlag: false,
        typeList: [],
        // Saif

        showScheduleCard: false,
        selectedScreenSeatTypes: [],
        selectedRateCardObject: {},

        CinemasList: [],
        MoviesList: [],
        ScreenList: [],
        RatecardsList: [],
        RatecardsListCopy: [],
        CinemasSettings: {
          cine_setting_id: null,
          cine_id: null,
          cine_operation_start_time: null,
          cine_operation_end_time: null,
          cine_cleaning_time_in_mins: null,
          cine_setting_ads_time_in_mins: null,
          cine_interval_time_in_mins: null,
          cine_seat_release_time_in_mins: null,
          cine_cutoff_time_in_mins: null,
          cine_setting_is_active: "Y",
        },
        selected: {
          cinema: "",
        },
        scheduleObject: {
          cinema_id: null,
          sch_start_date: moment().format(),
          sch_end_date: moment()
            .add(7, "d")
            .format(),
          sch_is_active: "Y",
        },
        selectedStatusId: 16,
        currentAdmits: 0,
        remainingAdmits: 0,
        BookingID: null,
        totalAdmits: 0,
        checkAdmitValid: false,
        AdmitError: "",
        zoomLevel: 3,
        // Saif
        greatest_start_time: 0,
        lowest_start_time: 0,
        hours: 40 / 60,
        time_range: [],
        screenCount: 0,
      };
    },
    computed: {
      ...mapGetters(["finalImagePath"]),
      selected_schedule_length() {
        return this.selected_delete_schedule.length;
      },
      selected_planned_schedule_length() {
        return this.selected_planned_schedule.length;
      },
      queryString() {
        let queryString = ``;
        let payload = {
          cinema_id: this.cinemaId,
          screen_id: this.screenId,
          start_date: moment(this.start_date).format("YYYY-MM-DD"),
          end_date: moment(this.end_date).format("YYYY-MM-DD"),
          type: this.status || null,
        };
        queryString = this.createQueryString(payload);
        return queryString;
      },
      filteredScheduleArray() {
        let statusArray = [];
        let otherStatusId = null;
        if (this.status == 1619) {
          statusArray.push(13, 16, 19);
        } else if (this.status == 16) {
          statusArray.push(this.status, 13);
        } else if ([1600, 3, 2].includes(this.status)) {
          otherStatusId = this.status;
          statusArray.push(13, 16, 19);
        } else {
          statusArray.push(this.status);
        }

        let tempArray = this.scheduleArray;
        this.lowest_start_time = 0;
        this.greatest_start_time = 0;
        let lowest_start = "";
        let greatest_start = "";
        let is_going_above = false;

        let finalResult = tempArray.map((obj) => {
          const filteredSubs = obj.screen_array.map((screen) => {
            let filterShows = screen.shows.filter((s) => {
              if (statusArray.includes(s.ss_show_status)) {
                s["show_time_in_number"] = this.checkMinuteTimeHour(
                  s.ss_start_show_time
                );
                s["end_time_in_number"] = this.checkMinuteTimeHour(
                  s.ss_end_show_time
                );
                if (s["end_time_in_number"] < s["show_time_in_number"]) {
                  let new_end_time_number = String(
                    `${parseInt(
                      parseInt(s["ss_end_show_time"].split(":")[0]) + 24
                    )}:${s["ss_end_show_time"].split(":")[1]}`
                  );
                  console.log(new_end_time_number, "dsfsdfsdf");
                  s["end_time_in_number"] = this.checkMinuteTimeHour(
                    new_end_time_number
                  );
                }
                if (
                  this.lowest_start_time > s["show_time_in_number"] ||
                  this.lowest_start_time == 0
                ) {
                  this.lowest_start_time = s["show_time_in_number"];
                  lowest_start = s.ss_start_show_time;
                }

                if (
                  this.greatest_start_time < s["end_time_in_number"] ||
                  this.greatest_start_time == 0
                ) {
                  this.greatest_start_time = s["end_time_in_number"];
                  greatest_start = s.ss_end_show_time;
                }
                return statusArray.includes(s.ss_show_status);
              }
            });
            if (otherStatusId) {
              if (otherStatusId == 1600) {
                filterShows = filterShows.filter((x) => x.is_event == "Y");
              } else if (otherStatusId == 3) {
                filterShows = filterShows.filter(
                  (x) => x.mycinema_booking_type_id == 3
                );
              } else if (otherStatusId == 2) {
                filterShows = filterShows.filter(
                  (x) =>
                    x.mycinema_booking_type_id == 2 ||
                    x.mycinema_booking_type_id == 1
                );
              }
            }
            return {
              ...screen,
              shows: filterShows,
            };
          });
          let nonEmptyScreen = filteredSubs.filter((z) => z.shows.length > 0);
          return {
            ...obj,
            screen_array: nonEmptyScreen,
          };
        });

        let nonEmptyArray = finalResult.filter((x) =>
          x.screen_array.some((y) => y.shows.length > 0)
        );
        if (nonEmptyArray.length > 0) {
          // is_going_above=true
          if (this.greatest_start_time > 24 * 60) {
            console.log(
              "Greatest start time",
              this.greatest_start_time,
              24 * 60
            );
          }
          console.log(lowest_start, greatest_start, is_going_above, "fsfsdfs");
          this.time_range = this.getIntervals(
            moment(
              moment().format("YYYY-MM-DD") + " " + lowest_start,
              "YYYY-MM-DD HH:mm"
            ).format("YYYY-MM-DD HH:mm"),
            moment(
              moment().format("YYYY-MM-DD") + " " + greatest_start,
              "YYYY-MM-DD HH:mm"
            ).format("YYYY-MM-DD HH:mm"),
            60
          );
          this.lowest_start_time = this.checkMinuteTimeHour(this.time_range[0]);
        }

        console.log("finalResult", finalResult, this.lowest_start_time);
        console.log("nonEmptyArray", nonEmptyArray);

        nonEmptyArray = _.orderBy(
          nonEmptyArray,
          [this.columnName],
          [this.orderby]
        );

        return nonEmptyArray;
      },
      zoomIndex() {
        if (this.zoomLevel == 1) {
          return 0.6;
        } else if (this.zoomLevel == 2) {
          return 0.8;
        } else if (this.zoomLevel == 3) {
          return 1;
        } else if (this.zoomLevel == 4) {
          return 1.2;
        }
      },
      getMaxLengthNew() {
        return (
          (this.greatest_start_time - this.lowest_start_time) * this.hours + 40
        );
      },
      getMaxLength() {
        let tempArray = [];
        this.screenCount = 0;
        this.scheduleArray.map((x) => {
          x.screen_array.map((y) => {
            if (y.shows.length > 0) {
              this.screenCount = this.screenCount + 1;
            }

            tempArray.push(y.shows.length);
          });
        });

        var maxLength = Math.max(...tempArray);
        console.log(maxLength, "maxLength");
        return maxLength;
      },
      seatType() {
        return this.seatLayoutData;
      },
      SelectedDate() {
        return this.scheduleObject.sch_start_date;
      },
      isStar() {
      return CLIENT_NAMES_OBJ.starcinemas.includes(String(this.CLIENT_SETUP_NAME));
    },
    },
    mounted() {
      console.log(
        "document.documentElement.scrollTop",
        document.documentElement.scrollTop
      );
      console.log("cleint-name=>",CLIENT_NAMES_OBJ.starcinemas.includes(String(this.CLIENT_SETUP_NAME)))
    },
    watch: {
      SelectedDate: function(val) {
        console.log("val", val);
        this.$store.dispatch("setSchDropDownDates", val);
      },
      finalImagePath(newval) {
        this.movieSelected.sch_artwork_url = newval;
        this.$forceUpdate();
      },
    },
    beforeMount: function() {
      this.getCinemaList();
      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      if (CinemaObj) {
        this.onSelectCinema(CinemaObj);
      }
      this.getPosAggregatorUsers();
      this.getCurrencyCode();
    },
    methods: {
      getviewingnumber() {
        this.viewingnumbers = [
          { name: "All", id: 1 },
          { name: "10", id: 2 },
          { name: "20", id: 3 },
          { name: "30", id: 3 },
          { name: "40", id: 4 },
          { name: "50", id: 5 },
        ];
      },
      onDropDownChangeValue(event) {
        if (event == "All") {
          this.perPage = this.rows;
          this.selectedvalue = event;
          this.onChangePagination();
        } else {
          this.selectedvalue = event;
          this.perPage = event;
          this.onChangePagination();
        }
      },

      /* eslint-disable */
      onChangePagination: function(event) {
        if (event === undefined) {
          this.currentPage = 1;
          this.getScheduleOverview();
        } else {
          this.currentPage = event;
          this.getScheduleOverview();
        }
      },
      onSortValue(columnName, orderby) {
        this.isSort = true;
        this.isAscending = !this.isAscending;
        this.columnName = columnName;
        this.orderby = orderby;
        this.getScheduleOverview();
      },
      filteredRateCardList(screen, screenType, tempArr = []) {
        let selectedScreen = _.cloneDeep(screen);
        let sst_id = screenType["sst_id"] || screenType["screen_seat_type_id"];
        let returnArray = [];
        let mappedRcArray = selectedScreen["selectedMappedRateCards"].filter(
          (x) => x.sst_id == sst_id
        );

        if (
          selectedScreen["selectedMappedRateCards"].length == 0 ||
          mappedRcArray.length == 0 ||
          !sst_id
        ) {
          returnArray = _.cloneDeep(tempArr);
        } else {
          returnArray = tempArr.filter((x) =>
            mappedRcArray.some((y) => y.rc_g_id == x.rc_g_id)
          );
        }
        return returnArray;
      },
      async beforeDownload({ html2pdf, options, pdfContent }) {
        const date = new Date();
        this.pdfFileName = "Schedule Overview" + date.getTime();
        this.htmlToPdfOptions.filename = this.pdfFileName;
        await html2pdf()
          .set(this.htmlToPdfOptions)
          .from(pdfContent)
          .toPdf()
          .get("pdf")
          .then((pdf) => {
            const totalPages = pdf.internal.getNumberOfPages();
            for (let i = 1; i <= totalPages; i++) {
              pdf.setPage(i);
              pdf.setFontSize(18);
              pdf.setTextColor(150);
              pdf.text(
                "Page " + i + " of " + totalPages,
                pdf.internal.pageSize.getWidth() * 0.88,
                pdf.internal.pageSize.getHeight() - 0.3
              );
            }
          })
          .save();
      },
      generateReport() {
        this.$refs.html2Pdf &&
          this.$refs.html2Pdf.generatePdf &&
          this.$refs.html2Pdf.generatePdf();
      },

      removeElement: function(element) {
        this.$refs.addonCharges.removeElement(element);
      },
      getAllAddonsCharges() {
        if (this.cinemaId) {
          this.AddonChargesArray = [];
          let payload = {
            cinema_id: this.cinemaId,
          };
          MasterService.getAllAddonsCharges(payload)
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.AddonChargesArray = data.Records.filter(
                  (z) => z.add_ons_price > 0 && z.is_addons_active == "Y"
                );
              } else {
                console.log("Error:", data.message);
              }
            })
            .catch((err) => {
              console.log("Error Catch:", err);
            });
        } else {
          console.log("Please Select Cinema: Get Addons Charges");
        }
      },
      checkStartTimeChageAllowed(movie, showToast = true) {
        let count = 0;
        if (
          movie.hasOwnProperty("unpaid_count") &&
          !isNaN(movie.unpaid_count) &&
          movie.unpaid_count > 0
        ) {
          count++;
        } else if (
          movie.hasOwnProperty("booked_seats") &&
          !isNaN(movie.booked_seats) &&
          movie.booked_seats > 0
        ) {
          count++;
        }
        if (count > 0) {
          if (showToast) {
            this.$toasted.show(
              "Transaction(s) found for this show. Edit Not Allowed."
            );
          }
          return true;
        } else {
          return false;
        }
      },
      checkIndicator(movie) {
        if (
          movie.sales_channel &&
          movie.sales_channel.length == movie.all_sales_channel_length
        ) {
          return false;
        } else {
          return true;
        }
      },
      onSelectStatus(event, status) {
        this.isChanged = true;
        this.movieSelected.ss_show_status = status.status_id;
        this.movieSelected.selectedShowStatus = status;
      },
      getMaxHeightForListViewScreen(dateScreenArr) {
        let MovieCount = 0;
        if (dateScreenArr.length > 0) {
          dateScreenArr.map((x) => {
            MovieCount += x.shows.length;
          });
        }
        return MovieCount;
      },
      onSelectRateCardFromEdit(event, movie, schPriceindex) {
        this.isChanged = true;
        let _Obj = {
          ...movie.scheduleShowPrice[schPriceindex],
          rate_card_id: event.rc_id,
          rc_name: event.rc_g_name,
          selectedRateCard: event,
          searchRateCard: "",
          rate_card_name: event.rc_g_name,
          rate_card_group_id: event.rc_g_id,
        };

        this.movieSelected.scheduleShowPrice[schPriceindex] = _.cloneDeep(_Obj);
        this.$forceUpdate();
      },
      getPopOverClassName(movie) {
        let className = `standard-header`;
        if (movie.isNewSchedule && movie.isReady) {
          className = `lightgreen-header`;
        } else if (movie.isNewSchedule && !movie.isReady) {
          className = `lightred-header`;
        } else if (movie.is_sch_disable == "Y") {
          className = `lightgrey-header`;
        } else if (movie.ss_show_status == 13) {
          className = `lightgrey-header`;
        } else if (movie.ss_show_status == 17) {
          className = `lightgrey-header`;
        } else if (movie.ss_show_status == 19) {
          className = `planned-header`;
        } else if (movie.mycinema_booking_type_id == 3) {
          className = `private-header`;
        } else if (
          movie.mycinema_booking_type_id == 2 ||
          movie.mycinema_booking_type_id == 1
        ) {
          className = `ondemand-header`;
        } else if (movie.is_event && movie.is_event == "Y") {
          className = `event-header`;
        } else {
          className = `standard-header`;
        }

        return className;
      },
      onSelectSalesChannel(event, movie) {
        console.log("SELECT EVENT", event);
        event["is_changed"] = true;
        event["value"] = "Y";
        event["ss_id"] = this.movieSelected.ss_id;
        event["md_id"] = this.movieSelected.md_id;
        let checkIndex = -1;
        checkIndex = this.movieSelected.sales_channel_changes.findIndex(
          (user) => user.user_id == event.user_id
        );
        if (checkIndex > -1) {
          this.movieSelected.sales_channel_changes.splice(checkIndex, 1);
          // this.movieSelected.sales_channel_changes.push(event)
        } else {
          this.movieSelected.sales_channel_changes.push(event);
        }
        console.log(
          "this.movieSelected.sales_channel_changes",
          this.movieSelected.sales_channel_changes
        );
      },
      onRemoveSalesChannel(event, movie) {
        console.log("Remove EVENT", event);
        event["is_changed"] = true;
        event["value"] = "N";
        event["ss_id"] = this.movieSelected.ss_id;
        event["md_id"] = this.movieSelected.md_id;
        let checkIndex = -1;
        checkIndex = this.movieSelected.sales_channel_changes.findIndex(
          (user) => user.user_id == event.user_id
        );
        if (checkIndex > -1) {
          this.movieSelected.sales_channel_changes.splice(checkIndex, 1);
          // this.movieSelected.sales_channel_changes.push(event)
        } else {
          this.movieSelected.sales_channel_changes.push(event);
        }
        console.log(
          "this.movieSelected.sales_channel_changes",
          this.movieSelected.sales_channel_changes
        );
      },
      getPosAggregatorUsers: function() {
        MasterService.GetPosAggregatorUsers()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.aggregatorUsersList = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            this.$toasted.show(err);
          });
      },
      onClickDeleteMultipleBtn() {
        this.allowDeleteSchedule = !this.allowDeleteSchedule;
        this.allowChangePlannedSchedule = false;
        this.selected_planned_schedule = [];
        this.selectAllPlannedMovie = false;
      },
      resetSelectedPlannedSchedule() {
        this.allowChangePlannedSchedule = false;
        this.selected_planned_schedule = [];
        this.selectAllPlannedMovie = false;
      },
      onClickSchPlannedMultipleBtn() {
        this.allowChangePlannedSchedule = !this.allowChangePlannedSchedule;
        this.allowDeleteSchedule = false;
        this.selected_delete_schedule = [];
        this.selectAllMoviesDel = false;
      },
      scheduleplannedSchedules: function(flag) {
        let loader = this.$loading.show();
        let payload = {
          scheduleList: this.selected_planned_schedule,
        };

        CinemasService.updateplannedschedule(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.selected_planned_schedule = [];
              this.allowChangePlannedSchedule = false;
              this.getScheduleOverview();
            } else {
              console.log("Error:", data.message);
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
            this.$bvModal.hide("open_muliple_planned_confirmation");
          });
      },
      onSortValue(columnName, orderby) {
        this.isSort = true;
        this.isAscending = !this.isAscending;
        this.columnName = columnName;
        this.orderby = orderby;
      },
      onSelectCheckboxDeleteShow() {
        if (this.selectAllMoviesDel) {
          this.selectAllMoviesDel = false;
        }
      },
      onSelectCheckboxOpenPlannedShow() {
        if (this.selectAllPlannedMovie) {
          this.selectAllPlannedMovie = false;
        }
      },
      checkMovieSelected(movie) {
        if (
          this.allowDeleteSchedule &&
          this.selected_delete_schedule.includes(movie)
        ) {
          if (
            movie.mycinema_booking_type_id > 0 ||
            movie.ss_show_status == 13 ||
            movie.ss_show_status == 17
          ) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      },
      onSelectMovieGridView(movie) {
        if (this.allowDeleteSchedule) {
          console.log(
            "include method",
            this.selected_delete_schedule.includes(movie)
          );
          let findIndex = -1;
          this.selected_delete_schedule.map((x, index) => {
            if (_.isEqual(x, movie)) {
              findIndex = index;
            }
          });
          if (findIndex > -1) {
            this.selected_delete_schedule.splice(findIndex, 1);
          } else {
            if (
              movie.booked_seats > 0 ||
              movie.unpaid_count > 0 ||
              movie.mycinema_booking_type_id > 0 ||
              movie.ss_show_status == 13 ||
              movie.ss_show_status == 17
            ) {
              return this.$toasted.show(
                "Unable to delete this show, Please Select Another show"
              );
            } else {
              this.selected_delete_schedule.push(movie);
            }
          }

          console.log(
            "this.selected_delete_schedule",
            this.selected_delete_schedule
          );
        }
      },
      onSelectAllDeleteMovies(event) {
        console.log("onSelectAllDeleteMovies Event", event);
        if (event) {
          this.selected_delete_schedule = [];
          this.filteredScheduleArray.map((x) => {
            x.screen_array.map((y) => {
              y.shows.map((z) => {
                if (
                  z.booked_seats > 0 ||
                  z.unpaid_count > 0 ||
                  z.mycinema_booking_type_id > 0 ||
                  z.ss_show_status == 13 ||
                  z.ss_show_status == 17
                ) {
                  console.log("Unable to select this movie");
                } else {
                  this.selected_delete_schedule.push(z);
                }
              });
            });
          });
        } else {
          this.selected_delete_schedule = [];
        }
      },
      onSelectAllPlannedMovies(event) {
        if (event) {
          this.selected_planned_schedule = [];
          this.filteredScheduleArray.map((x) => {
            x.screen_array.map((y) => {
              y.shows.map((z) => {
                if (z.ss_show_status == 19) {
                  this.selected_planned_schedule.push(z);
                }
              });
            });
          });
        } else {
          this.selected_planned_schedule = [];
        }
      },
      getHourWidthLine() {
        return 40 + 180 * this.screenCount;
      },
      getMaxHorizonLen(screenArr) {
        let val = 225 * screenArr.length;
        return val;
      },
      handleCloseModal() {
        this.multi_schedule_delete_reason = "";
      },
      handleDeleteMultipleSchedule() {
        this.disableDeleteBtn = true;
        console.log("selected_delete_schedule", this.selected_delete_schedule);
        let payload = {
          selectedSchedules: this.selected_delete_schedule,
          delete_reason: this.multi_schedule_delete_reason,
        };
        scheduleService
          .deleteMultipleSchedule(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.disableDeleteBtn = false;
              this.selected_delete_schedule = [];
              this.allowDeleteSchedule = false;
              this.getScheduleOverview();
            } else {
              this.disableDeleteBtn = false;
              console.log("Error:", data.message);
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            this.disableDeleteBtn = false;
            this.$bvModal.hide("delete_muliple_confirmation");
          });
      },
      checkMinuteTimeHour(show_time) {
        let show_time_split = show_time.split(":");
        let movie_minute_new =
          parseInt(show_time_split[0]) * 60 + parseInt(show_time_split[1]);

        return movie_minute_new || 0;
      },

      getIntervals(start_time, end_time, interval_time) {
        var start = moment(start_time, "YYYY-MM-DD hh:mm a");
        var end = moment(end_time, "YYYY-MM-DD hh:mm a");
        if (start_time && end_time && moment(end_time).isBefore(start_time)) {
          end = moment(end_time, "YYYY-MM-DD hh:mm a").add(1, "days");
        }
        console.log("end2222", end);

        if (interval_time == "00" || interval_time == 0) {
          interval_time = 60;
        }

        start.minutes(Math.floor(start.minutes() / 60) * 60);

        var result = [];

        var current = moment(start);

        while (current <= end) {
          result.push(current.format("HH:mm"));
          current.add(interval_time, "minutes");
        }

        return result;
      },
      getHourWidth(size) {
        let topSize = size * 60 * this.hours;
        return topSize + 7;
      },
      getTopSize(size) {
        let topSize = size - this.lowest_start_time;
        return this.hours * topSize + 7 + "px";
      },
      getMovieBoxHeight(size) {
        let topSize = size;
        return this.hours * topSize + "px";
      },
      moment,
      createQueryString,
      zoomIn(type) {
        if (type == "add") {
          if (this.zoomLevel < 4) {
            this.zoomLevel++;
          }
        } else if (type == "minus") {
          if (this.zoomLevel > 1) {
            this.zoomLevel--;
          }
        }
      },
      viewType: function(viewType) {
        if (viewType == "grid") {
          this.gridView = true;
          this.resetSelectedPlannedSchedule();
          this.getScheduleOverview();
        } else if ((viewType = "list")) {
          this.gridView = false;
        }
      },
      getColorClass(movie) {
        let className = ``;

        if (movie.ss_show_status == 16) {
          className = "status-green-2";
        } else if (movie.ss_show_status == 19) {
          className = "status-yellow-2";
        } else if (movie.ss_show_status == 13) {
          className = "status-grey-2";
        } else if (movie.ss_show_status == 17) {
          className = "";
        }

        return className;
      },
      getRateCardName(rc) {
        let tempArray = [];
        let seatType = "";
        let rc_g_name = "";
        let price = 0;
        let text = ``;
        tempArray = this.RatecardsList.filter(
          (x) => x.rc_g_id == rc.rate_card_group_id
        );
        let selectedRc = tempArray.length > 0 ? tempArray[0] : "";
        if (selectedRc) {
          rc_g_name = selectedRc.rc_g_name;
          seatType = rc.sst_seat_type;
          price = this.currFormat(selectedRc.rc_total_amount);

          text = seatType + "-" + rc_g_name + "-" + price;
        }

        return text;
      },
      clearDate() {
        if (type == "start") {
          this.start_date = "";
        } else if (type == "end") {
          this.end_date = "";
        }
      },
      onChangeDate(type) {
        if (type == "start_date") {
          this.end_date = moment(this.start_date)
            .add(7, "d")
            .format();
          // this.disabledDatesTo.from = new Date(moment(this.end_date).format());
        }
        this.getScheduleOverview();
      },
      onClickDisableDates() {
        console.log("Disable Date");
      },
      onSubmitAdmits: function() {
        if (!this.checkAdmitValid) {
          return this.$toasted.show(this.AdmitError);
        }
        let payload = {
          seats: "All",
          booking_id: this.BookingID,
          isPrivateShow: true,
          current_admits: parseInt(this.currentAdmits),
        };
        scheduleService
          .updateAdmits(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.$toasted.show(data.message);
              this.getSchedule();
              this.$refs.admits.hide();
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            this.$toasted.show("something went wrong");
          });
      },
      handleAdmitChange: function(type) {
        if (type === "add") {
          if (this.currentAdmits + 1 <= this.remainingAdmits)
            this.currentAdmits += 1;
          else this.$toasted.show("Reached Max Seat Limit In Audi");
        } else if (type === "sub") {
          if (this.currentAdmits - 1 >= 0) this.currentAdmits -= 1;
        }
      },
      handleInputChange($event) {
        let num = $event.target.value;
        if (num < 0) {
          this.AdmitError = "Cannot have negative values";
          this.checkAdmitValid = false;
        } else if (num > this.remainingAdmits) {
          this.AdmitError = "Exceeded Seat Limit in Audi";
          this.checkAdmitValid = false;
        } else {
          this.checkAdmitValid = true;
        }
      },
      showAdmitModal(show) {
        console.log("show", show);
        this.currentAdmits = 0;
        this.BookingID =
          show.hasOwnProperty("privateShowBookingDetails") &&
          show.privateShowBookingDetails.sb_booking_code
            ? show.privateShowBookingDetails.sb_booking_code
            : null;

        this.remainingAdmits = show.screen_total_seats;
        this.totalAdmits = show.admits;
        this.$refs.admits.show();
      },
      onDeleteMovie: function(
        screen,
        screenMovie,
        screenIndex,
        screenMovieIndex
      ) {
        let movie_name_format = `${screenMovie.movie_title} ${screenMovie.mf_name} (${screenMovie.lang_name})`;
        this.isChanged = true;
        this.deleteSubmit = true;
        this.$validator
          .validate()
          .then((valid) => {
            if (valid) {
              this.$refs.deleteMovieModal.hide();

              let ss_id = screenMovie.scheduleShowPrice.map((x) => {
                return x.schedule_show_id;
              });
              if (ss_id && ss_id.length > 0) {
                let payload = {
                  ss_id: ss_id[0],
                  delete_reason: this.movieSelected.delete_reason,
                  movie_name_format: movie_name_format,
                  ss_actual_start_date_time:
                    screenMovie.ss_actual_start_date_time,
                  ss_start_date: screenMovie.ss_start_date,
                };
                scheduleService
                  .UpdateShowStatus(payload)
                  .then((response) => {
                    const { data } = response;
                    if (data && data.status) {
                      this.getScheduleOverview();
                      this.$toasted.show(data.message);
                    } else {
                      this.$toasted.show(data.message);
                    }
                  })
                  .catch((err) => {
                    this.$toasted.show(err);
                  })
                  .finally(() => {});
              }
            }
          })
          .catch(this._CatchError);
      },
      onDeleteMovieModal: function(
        screen,
        screenMovie,
        screenIndex,
        screenMovieIndex
      ) {
        if (
          this.movieSelected.hasOwnProperty("isNewSchedule") &&
          this.movieSelected.isNewSchedule == false
        ) {
          this.selectedScreen = screen;
          this.movieSelected = screenMovie;
          this.selectedScreenIndex = screenIndex;
          this.selectedMovieIndex = screenMovieIndex;
          let ss_id = screenMovie.scheduleShowPrice.map((x) => {
            return x.schedule_show_id;
          });
          if (ss_id && ss_id.length > 0) {
            RefundService.GetShowTransaction({ ss_id: ss_id[0] })
              .then((response) => {
                const { data } = response;
                if (data.status) {
                  if (data.Records.length > 0) {
                    this.$toasted.show(
                      data.Records.length +
                        " transaction(s) wfound for this show. Please apply for refund module"
                    );
                  } else if (
                    screenMovie.unpaid_count &&
                    screenMovie.unpaid_count > 0
                  ) {
                    this.$toasted.show(
                      `(${screenMovie.unpaid_count}) Unpaid transaction(s) found, Please Cancel Unpaid Booking.`
                    );
                  } else {
                    this.isMovieCardSelected = false;
                    this.$refs.deleteMovieModal.show();
                  }
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch((err) => {
                this.$toasted.show("Something went wrong!");
              });
          } else {
            this.$toasted.show("Something went wrong!");
          }
        }
      },
      onClickupdateRateCard: function() {
        if (
          (this.selectedRateCardObject &&
            Object.keys(this.selectedRateCardObject).length == 0) ||
          String(this.selectedRateCardObject.SeatTypeIndex).length == 0
        ) {
          this.$toasted.show("Please Select Rate Card Group");
          return;
        }

        let payload = {
          show_schedule_id: this.movieSelected.show_schedule_id,
          scheduleshowprice: this.movieSelected.scheduleShowPrice,
        };
        console.log("payload :>> ", payload);
        scheduleService
          .UpdateCinemaScheduleByPrice(payload)
          .then((result) => {
            const { data } = result;
            if (data.status) {
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            this.$toasted.show(this._CatchError);
          });
        this.searchRateCard = "";
      },
      onChangeRateCard: function(event, seat, SeatTypeIndex) {
        console.log("event :>> ", event);
        this.selectedRateCardObject.rate_card_id = event.rc_id;
        this.selectedRateCardObject.screen_seat_type_id = seat.sst_id;
        this.selectedRateCardObject.SeatTypeIndex = SeatTypeIndex;
        this.selectedRateCardObject.rate_card_group_id = event.rc_g_id;

        this.movieSelected.scheduleShowPrice[
          this.selectedRateCardObject.SeatTypeIndex
        ]["rc_name"] = event.rc_g_name;
        this.movieSelected.scheduleShowPrice[
          this.selectedRateCardObject.SeatTypeIndex
        ]["rate_card_group_id"] = event.rc_g_id;
        this.movieSelected.scheduleShowPrice[
          this.selectedRateCardObject.SeatTypeIndex
        ]["rate_card_id"] = this.selectedRateCardObject.rate_card_id;
        this.movieSelected.scheduleShowPrice[
          this.selectedRateCardObject.SeatTypeIndex
        ][
          "screen_seat_type_id"
        ] = this.selectedRateCardObject.screen_seat_type_id;
        console.log("object :", this.selectedRateCardObject);

        console.log("TO DO Integrate Rate CArd");
      },
      onOpenAddPriceModal: function(
        screen,
        screenMovie,
        screenIndex,
        screenMovieIndex
      ) {
        this.movieSelected = screenMovie;
        let tempScreen = this.screenList.filter(
          (x) => x.screen_id == screen.screen_id
        );
        this.selectedScreenSeatTypes =
          tempScreen.length > 0 ? tempScreen[0].screen_seat_types : [];
        this.selectedMovieIndex = screenMovieIndex;
        this.selectedScreenIndex = screenIndex;
        console.log(
          " this.selectedScreenSeatTypes ",
          this.selectedScreenSeatTypes
        );
        this.$refs.ratecardmodal.show();
      },
      onClickViewSeatLayout({ md_id, screen_id, ss_id }) {
        this.getScreenData(screen_id);
        this.GET_SEAT_LAYOUT({ ss_id, md_id, screen_id });
        this.getCurrencyCode();
        this.$refs.viewSeatLayoutModal.show();
      },
      async GET_SEAT_LAYOUT(payload) {
        console.log("payload :", payload);
        let loader = this.$loading.show();
        let data = {};
        let seats = await PosService.PosGetSeatLayout({
          screen_id: payload.screen_id,
          ss_id: payload.ss_id,
          md_id: payload.md_id,
        });
        data.seats = seats.data;
        let seatType = await PosService.getSeatType({
          screen_id: payload.screen_id,
          ss_id: payload.ss_id,
          md_id: payload.md_id,
        });

        data.seatType = seatType.data;

        loader.hide();
        if (seats && seats.status) {
          let seatData = [];
          let seatData1 = groupBy(data.seats.Records, "sst_seat_type");
          data.seatType.Records = data.seatType.Records.sort(function(a, b) {
            return a.sst_order - b.sst_order;
          });
          data.seatType.Records.map((type) => {
            for (var key in seatData1) {
              if (seatData1.hasOwnProperty(key)) {
                if (key == type.sst_seat_type) {
                  seatData[key] = seatData1[key];
                }
              }
            }
          });
          let tempArray = [];
          for (let key in seatData) {
            if (seatData.hasOwnProperty(key)) {
              let seat_price = 0;
              let seat_price_obj = seatData[key].filter((x) => {
                return x;
              });
              if (seat_price_obj) {
                seat_price = seat_price_obj[0].seat_price;
              }
              tempArray.push({
                seatType: key,
                seat_price: seat_price,
                seats: seatData[key],
              });
            }
          }
          let finalArray = [];
          for (let i = 0; i < tempArray.length; i++) {
            let singleSeatType = tempArray[i];

            let seatData_1 = groupBy(singleSeatType.seats, "sl_row_num");
            let tempArray_1 = [];
            for (let key in seatData_1) {
              if (seatData_1.hasOwnProperty(key)) {
                let seatData_2 = seatData_1[key].map((singleSeat) => {
                  singleSeat.selectStatus = false;
                  singleSeat.SelectStatusFlag = false;
                  return singleSeat;
                });
                seatData_2 = seatData_2.sort(function(a, b) {
                  return a.sl_col_num - b.sl_col_num;
                });

                tempArray_1.push(seatData_2);
              }
            }
            tempArray[i].seatsFinal = tempArray_1;
          }
          this.seatLayoutData = tempArray;
        } else {
          this.$toasted.show(data.message || "Please try later");
        }
      },
      convertToHrs: function(value) {
        let hours = Math.floor(value / 60);
        let minutes = Math.floor(value % 60);
        return hours + " hrs " + minutes + " mins";
      },
      newGetScreenPositionCalc: function(hours, minutes) {
        hours = parseInt(hours.split(":")[0]);
        let hourCal = 0;
        let selected = 0;
        this.intervalsArray.map((intervalHour, index) => {
          if (
            parseInt(intervalHour.split(" ")[1].split(":")[0]) == hours &&
            selected == 0
          ) {
            hourCal = index;
            selected = 1;
          }
        });
        let totalMinutes = parseInt(hourCal * 60) + parseInt(minutes);
        let leftShift = parseInt(totalMinutes * 50) / 60;
        return leftShift;
      },
      getScheduleChecker: function() {
        //TO DO Check this function
        let currentDate = "";
        let end_time = "";
        if (
          moment(
            moment().format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_start_time
          ).isSameOrAfter(
            moment(
              moment().format("YYYY-MM-DD") +
                " " +
                this.CinemasSettings.cine_operation_end_time
            )
          )
        ) {
          if (
            moment(
              moment().format("YYYY-MM-DD") +
                " " +
                this.CinemasSettings.cine_operation_end_time
            ).isAfter(
              moment(
                moment().format("YYYY-MM-DD") +
                  " " +
                  moment(this.movieSelected.selected_time).format("HH:mm")
              )
            )
          ) {
            this.currentDate =
              moment(this.movieSelected.ss_start_date)
                .add(1, "days")
                .format("YYYY-MM-DD") +
              " " +
              moment(this.movieSelected.selected_time).format("HH:mm");
            this.currentDate = moment(this.currentDate).valueOf();

            this.end_time = moment(
              moment(this.movieSelected.ss_start_date)
                .add(1, "days")
                .format("YYYY-MM-DD") +
                " " +
                moment(this.movieSelected.selected_time).format("HH:mm")
            )
              .add(parseInt(this.movieSelected.lengthMinutes), "m")
              .toDate();

            this.end_time = moment(this.end_time).valueOf();
          } else {
            this.currentDate =
              moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD") +
              " " +
              moment(this.movieSelected.selected_time).format("HH:mm");

            this.currentDate = moment(this.currentDate).valueOf();

            this.end_time = moment(
              moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD") +
                " " +
                moment(this.movieSelected.selected_time).format("HH:mm")
            )
              .add(parseInt(this.movieSelected.lengthMinutes), "m")
              .toDate();

            this.end_time = moment(this.end_time).valueOf();
          }
        } else {
          this.currentDate =
            moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD") +
            " " +
            moment(this.movieSelected.selected_time).format("HH:mm");

          this.currentDate = moment(this.currentDate).valueOf();
          this.end_time = moment(
            moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD") +
              " " +
              moment(this.movieSelected.selected_time).format("HH:mm")
          )
            .add(parseInt(this.movieSelected.lengthMinutes), "m")
            .toDate();

          this.end_time = moment(this.end_time).valueOf();
        }

        return new Promise((resolve, reject) => {
          let payload = {
            cinema_id: this.scheduleObject.cinema_id,
            start_date: moment(this.movieSelected.ss_start_date).format(
              "YYYY-MM-DD"
            ),
            end_date: moment(this.movieSelected.ss_end_date).format(
              "YYYY-MM-DD"
            ),
            groupbyssid: "Y",
          };
          scheduleService
            .GetCinemaSchedule(payload)
            .then((result) => {
              const { data } = result;
              if (data && data.status && data.Records.length > 0) {
                let newRecords = data.Records;
                let array = [];

                for (let index = 0; index < newRecords.length; index++) {
                  const element = newRecords[index];
                  if (
                    element.ss_id !=
                    this.movieSelected.scheduleShowPrice[0].schedule_show_id
                  ) {
                    let old_movie_start_date = moment(
                      element.ss_actual_start_date_time
                    )
                      .tz(this.timeZone.tz_name)

                      .format("YYYY-MM-DD HH:mm:ss");
                    let old_movie_end_date = moment(
                      element.ss_actual_end_date_time
                    )
                      .tz(this.timeZone.tz_name)

                      .format("YYYY-MM-DD HH:mm:ss");
                    let new_movie_end_date = moment(this.end_time).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );
                    let new_movie_start_date = moment(this.currentDate).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );

                    let valid = moment(old_movie_end_date).isBetween(
                      new_movie_start_date,
                      new_movie_end_date
                    );
                    let validSame = moment(old_movie_end_date).isSame(
                      new_movie_end_date
                    );
                    let validSame1 = moment(old_movie_start_date).isSame(
                      new_movie_start_date
                    );
                    let valid1 = moment(new_movie_end_date).isBetween(
                      old_movie_start_date,
                      old_movie_end_date
                    );
                    console.log("valid :>> ", valid);
                    console.log("validSame :>> ", validSame);
                    console.log("validSame1 :>> ", validSame1);
                    console.log("valid1 :>> ", valid1);
                    console.log(
                      " this.selectedScreen.screen_id :>> ",
                      this.selectedScreen.screen_id
                    );
                    if (
                      element.screen_id == this.selectedScreen.screen_id &&
                      valid1
                    ) {
                      resolve({
                        status: false,
                        message:
                          "Movie overlapped, Please select different showtime",
                      });
                      break;
                    } else if (
                      element.screen_id == this.selectedScreen.screen_id &&
                      valid
                    ) {
                      resolve({
                        status: false,
                        message:
                          "Movie overlapped, Please select different showtime",
                      });
                      break;
                    } else if (
                      element.screen_id == this.selectedScreen.screen_id &&
                      validSame
                    ) {
                      resolve({
                        status: false,
                        message:
                          "Movie overlapped, Please select different showtime",
                      });
                      break;
                    } else if (
                      element.screen_id == this.selectedScreen.screen_id &&
                      validSame1
                    ) {
                      resolve({
                        status: false,
                        message:
                          "Movie overlapped, Please select different showtime",
                      });
                      break;
                    } else {
                      array.push(element.ss_start_show_time);
                      if (array.length === newRecords.length) {
                        resolve({ status: true });
                        break;
                      } else {
                        resolve({ status: true });
                      }
                    }
                  } else {
                    resolve({ status: true });
                  }
                }
              } else {
                resolve({ status: true });
              }
            })
            .catch((err) => {
              resolve({ status: false, message: "overlaps", error: err });
            });
        });
      },
      onChangeTimePicker: function(date) {
        date = new Date(date);
        var hours = date.getHours();
        var minutes = date.getMinutes();
        hours = hours < 10 ? "0" + hours : hours;
        minutes = minutes < 10 ? "0" + minutes : minutes;
        var strTime = hours + ":" + minutes;
        return strTime;
      },
      onUpdate: function() {
        if (!this.movieSelected.start_time) {
          this.$toasted.show("Please Select Start Time!");
          return false;
        }
        this.getScheduleChecker()
          .then((result) => {
            if (!result.status) {
              this.$toasted.show(result.message);
            } else if (result.status) {
              let start = 0;
              let old_show_time =
                this.movieSelected.ss_actual_start_date_time || null;
              let movie_name_format = `${this.movieSelected.movie_title} ${this.movieSelected.mf_name} (${this.movieSelected.lang_name})`;

              let ss_actual_start_date_time = null;
              let ss_actual_end_date_time = null;
              let ss_actual_start_date = null;
              let ss_actual_end_date = null;
              let ss_end_date = null;
              let ss_end_date_time = null;

              this.movieSelected.start_time = this.onChangeTimePicker(
                this.movieSelected.selected_time
              );
              start = this.newGetScreenPositionCalc(
                this.movieSelected.start_time,
                this.movieSelected.start_time.split(":")[1]
              );
              this.movieSelected.start = start;
              let end_time = moment(this.movieSelected.selected_time)
                .add(parseInt(this.movieSelected.lengthMinutes), "m")
                .toDate();
              this.movieSelected.end_time = moment(end_time).format("HH:mm");

              let date = moment(this.start_date).format("YYYY-MM-DD");
              let showtime = format24Hours(date, this.movieSelected.start_time);
              let endShowtime = format24Hours(
                date,
                this.movieSelected.end_time
              );
              let ss_start_date_time = +new Date(
                moment(date).format("YYYY-MM-DD") +
                  "T" +
                  showtime +
                  this.timeZone.tz_utc_offset
              );

              function format24Hours(date, time) {
                let newVal = date + " " + time;
                let finalVal = moment(newVal).format("HH:mm");
                return finalVal;
              }

              if (
                moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_start_time
                ).isSameOrAfter(
                  moment(
                    moment().format("YYYY-MM-DD") +
                      " " +
                      this.CinemasSettings.cine_operation_end_time
                  )
                )
              ) {
                if (
                  moment(
                    moment().format("YYYY-MM-DD") +
                      " " +
                      this.CinemasSettings.cine_operation_end_time
                  ).isAfter(
                    moment(
                      moment().format("YYYY-MM-DD") +
                        " " +
                        this.movieSelected.start_time
                    )
                  )
                ) {
                  ss_actual_start_date = moment(date)
                    .add(1, "days")
                    .format("YYYY-MM-DD");
                  ss_actual_start_date_time = +new Date(
                    moment(date)
                      .add(1, "days")
                      .format("YYYY-MM-DD") +
                      "T" +
                      showtime +
                      this.timeZone.tz_utc_offset
                  );
                  ss_actual_end_date = moment(date)
                    .add(1, "days")
                    .format("YYYY-MM-DD");
                  ss_actual_end_date_time = +new Date(
                    moment(date)
                      .add(1, "days")
                      .format("YYYY-MM-DD") +
                      "T" +
                      endShowtime +
                      this.timeZone.tz_utc_offset
                  );
                  ss_end_date = moment(date)
                    .add(1, "days")
                    .format("YYYY-MM-DD");

                  ss_end_date_time = +new Date(
                    moment(date)
                      .add(1, "days")
                      .format("YYYY-MM-DD") +
                      "T" +
                      endShowtime +
                      this.timeZone.tz_utc_offset
                  );
                } else {
                  ss_actual_start_date = moment(date).format("YYYY-MM-DD");
                  ss_actual_start_date_time = +new Date(
                    moment(date).format("YYYY-MM-DD") +
                      "T" +
                      showtime +
                      this.timeZone.tz_utc_offset
                  );
                  ss_actual_end_date =
                    this.movieSelected.start_time.split(" ")[1] == "PM" &&
                    this.movieSelected.end_time.split(" ")[1] == "AM"
                      ? moment(date)
                          .add(1, "days")
                          .format("YYYY-MM-DD")
                      : moment(date).format("YYYY-MM-DD");

                  ss_actual_end_date_time =
                    this.movieSelected.start_time.split(" ")[1] == "PM" &&
                    this.movieSelected.end_time.split(" ")[1] == "AM"
                      ? +new Date(
                          moment(date)
                            .add(1, "days")
                            .format("YYYY-MM-DD") +
                            "T" +
                            endShowtime +
                            this.timeZone.tz_utc_offset
                        )
                      : +new Date(
                          moment(date).format("YYYY-MM-DD") +
                            "T" +
                            endShowtime +
                            this.timeZone.tz_utc_offset
                        );
                  ss_end_date =
                    this.movieSelected.start_time.split(" ")[1] == "PM" &&
                    this.movieSelected.end_time.split(" ")[1] == "AM"
                      ? moment(date)
                          .add(1, "days")
                          .format("YYYY-MM-DD")
                      : moment(date).format("YYYY-MM-DD");

                  ss_end_date_time =
                    this.movieSelected.start_time.split(" ")[1] == "PM" &&
                    this.movieSelected.end_time.split(" ")[1] == "AM"
                      ? +new Date(
                          moment(date)
                            .add(1, "days")
                            .format("YYYY-MM-DD") +
                            "T" +
                            endShowtime +
                            this.timeZone.tz_utc_offset
                        )
                      : +new Date(
                          moment(date).format("YYYY-MM-DD") +
                            "T" +
                            endShowtime +
                            this.timeZone.tz_utc_offset
                        );
                }
              } else {
                ss_actual_start_date = moment(date).format("YYYY-MM-DD");
                ss_actual_start_date_time = +new Date(
                  moment(date).format("YYYY-MM-DD") +
                    "T" +
                    showtime +
                    this.timeZone.tz_utc_offset
                );
                ss_actual_end_date =
                  this.movieSelected.start_time.split(" ")[1] == "PM" &&
                  this.movieSelected.end_time.split(" ")[1] == "AM"
                    ? moment(date)
                        .add(1, "days")
                        .format("YYYY-MM-DD")
                    : moment(date).format("YYYY-MM-DD");

                ss_actual_end_date_time =
                  this.movieSelected.start_time.split(" ")[1] == "PM" &&
                  this.movieSelected.end_time.split(" ")[1] == "AM"
                    ? +new Date(
                        moment(date)
                          .add(1, "days")
                          .format("YYYY-MM-DD") +
                          "T" +
                          endShowtime +
                          this.timeZone.tz_utc_offset
                      )
                    : +new Date(
                        moment(date).format("YYYY-MM-DD") +
                          "T" +
                          endShowtime +
                          this.timeZone.tz_utc_offset
                      );
                ss_end_date =
                  this.movieSelected.start_time.split(" ")[1] == "PM" &&
                  this.movieSelected.end_time.split(" ")[1] == "AM"
                    ? moment(date)
                        .add(1, "days")
                        .format("YYYY-MM-DD")
                    : moment(date).format("YYYY-MM-DD");

                ss_end_date_time =
                  this.movieSelected.start_time.split(" ")[1] == "PM" &&
                  this.movieSelected.end_time.split(" ")[1] == "AM"
                    ? +new Date(
                        moment(date)
                          .add(1, "days")
                          .format("YYYY-MM-DD") +
                          "T" +
                          endShowtime +
                          this.timeZone.tz_utc_offset
                      )
                    : +new Date(
                        moment(date).format("YYYY-MM-DD") +
                          "T" +
                          endShowtime +
                          this.timeZone.tz_utc_offset
                      );
              }
              if (
                this.movieSelected.hasOwnProperty("isNewSchedule") &&
                this.movieSelected.isNewSchedule == false
              ) {
                let payload = {
                  show_schedule_id: this.movieSelected.scheduleShowPrice[0]
                    .schedule_show_id,
                  screen_id: this.movieSelected.scheduleShowPrice[0].screen_id,
                  interval_time_in_mins:
                    this.movieSelected.interval_time_in_mins || 0,
                  cleaning_time_in_mins:
                    this.movieSelected.cleaning_time_in_mins || 0,
                  ads_time_in_mins: this.movieSelected.ads_time_in_mins || 0,
                  ss_start_show_time: showtime, // this.movieSelected.start_time,
                  ss_end_show_time: endShowtime, // this.movieSelected.end_time,
                  ss_start_date_time: ss_start_date_time,
                  ss_end_date_time: ss_end_date_time,
                  ss_show_status: this.movieSelected.ss_show_status,
                  ss_actual_end_date: ss_actual_end_date,
                  ss_actual_end_date_time: ss_actual_end_date_time,
                  ss_actual_start_date: ss_actual_start_date,
                  ss_actual_start_date_time: ss_actual_start_date_time,
                  old_show_time: old_show_time,
                  sch_artwork_url: this.movieSelected.sch_artwork_url,
                  movie_format_name: movie_name_format,
                  ss_comment: this.movieSelected.ss_comment,
                  scheduleShowPrice: this.movieSelected.scheduleShowPrice,
                  sales_channel_changes: this.movieSelected
                    .sales_channel_changes,
                  AddonsCharges: this.movieSelected.AddonsCharges,
                };
                scheduleService
                  .UpdateCinemaScheduleByShow(payload)
                  .then((result) => {
                    const { data } = result;
                    if (data.status) {
                      this.getScheduleOverview();
                      this.$toasted.show(data.message);
                    } else {
                      this.$toasted.show(data.message);
                    }
                  })
                  .catch((err) => {
                    this.$toasted.show(err);
                  });
              }
            } else {
              this.$toasted.show(data.message);
            }
            this.$refs.updateMovie.hide();
          })
          .catch((err) => {
            this.$refs.updateMovie.hide();

            this.$toasted.show(err);
          });
      },
      onEditMovie(screenMovie, screen, screenIndex) {
        this.movieSelected = _.cloneDeep(screenMovie);
        this.selectedScreen =
          this.ScreenArray.find((x) => x.screen_id == screen.screen_id) ||
          screen;
        this.selectedScreenIndex = screenIndex;
        this.movieSelected.startTime2 = screenMovie.ss_start_show_time;
        this.movieSelected["selected_time"] =
          moment().format("YYYY-MM-DD") + " " + screenMovie.start_time;
        this.$refs["updateMovie"].show();
      },
      getCurrencyCode() {
        let payload = {
          tableName: "ms_currencies",
          curr_is_active: "Y",
          curr_id:
            this.secureStore.get("BRGLOPCU") &&
            this.secureStore.get("BRGLOPCU").go_value,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.currencyData = data.Records[0];
            } else {
              // Show Error Message:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error on getActiveScreenByCinemaId :", error);
          });
      },
      onSelectShowType(status) {
        this.showTypeFilter = status;
        this.status = status.status_id;
        this.getScheduleOverview();
      },
      getAllActiveScreens: function(cinema_id) {
        this.screenList = [];
        let payload = {
          cinema_id: cinema_id || this.cinemaId,
        };

        scheduleService
          .GetScreens(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.screenList = data.Records.filter(
                (x) => x.screen_seat_types.length > 0
              );
              this.ScreenArray = data.Records.filter(
                (x) => x.screen_seat_types.length > 0
              );
              console.log(" this.ScreenArray", this.ScreenArray);
              let obj = {
                screen_name: "All",
                screen_id: null,
                cinema_id: 0,
              };
              this.screenList.unshift(obj);
              this.selectedScreendd = obj;
            } else {
              console.log("data.message :", data.message);
            }
          })
          .catch(this._CatchError);
      },
      getScreenData(screen_id) {
        let payload = {
          tableName: "screens",
          screen_id: screen_id,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.screenObj = data.Records[0];
            } else {
              // Show Error Message:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error on getScreenData :", error);
          });
      },

      onSelectScreen(screen) {
        this.selectedScreendd = screen;
        this.screenId = screen.screen_id;
        this.getScheduleOverview();
      },
      getScheduleOverview(isPdf="N") {
        if (!this.cinemaId) {
          return this.$toasted.show("Please select cinema");
        } else if (!this.start_date) {
          return this.$toasted.show("Please select Start Date");
        } else if (!this.end_date) {
          return this.$toasted.show("Please select End Date");
        } else if (moment(this.start_date).isAfter(this.end_date)) {
          return this.$toasted.show(
            "Please Start Date Cannot be Greater than End Date"
          );
        } else {
          let loader = this.$loading.show();
          this.scheduleArray = [];
          let self = this;
          let payload = {
            cinema_id: this.cinemaId,
            screen_id: this.screenId,
            start_date: moment(this.start_date).format("YYYY-MM-DD"),
            end_date: moment(this.end_date).format("YYYY-MM-DD"),
            type: this.status || null,
            cinema_name:this.selectedCinema.cine_name || "",
            cinema_address:this.selectedCinema.cine_address || "",
            isPdf
          };

          if (!this.gridView) {
            payload["limit"] = this.perPage;
            payload["currentPage"] = this.currentPage;
            payload["searchValue"] = this.searchValue;
            payload["orderBy"] = this.orderBy;
            payload["columnName"] = this.columnName;
          }

          scheduleService
            .GetScheduleOverview(payload)
            .then((response) => {
              const { data } = response;
              if (data.typeList.length > 0) {
                this.typeList = data.typeList;
              }
              if (
                data.hasOwnProperty("totalCount") &&
                (data.totalCount || data.totalCount == 0)
              ) {
                this.rows = data.totalCount;
              }
              if (data.status && data.Records.length > 0) {
                this.scheduleArray = data.Records;
                this.lowest_start_time = data.lowest_start_time;
                this.greatest_start_time = data.greatest_start_time;
                this.time_range = data.time_array;
                this.scheduleArray.forEach((x) => {
                  x.screen_array.forEach((z) => {
                    z.shows.forEach((y) => {
                      let lengthMinutes =
                        parseInt(y.mrrdr_runtime || 0) +
                        parseInt(y.ads_time_in_mins || 0) +
                        parseInt(y.cleaning_time_in_mins || 0) +
                        parseInt(y.interval_time_in_mins || 0);
                      let sign = self.timeZone.tz_utc_offset.charAt(0);
                      let offset = self.timeZone.tz_utc_offset.substring(1);
                      let hours = offset.split(":")[0];
                      let minutes = offset.split(":")[1];

                      let timeZoneFlag =
                        momentT.tz.guess() === self.timeZone.tz_name ||
                        ((momentT.tz.guess() == "Asia/Calcutta" ||
                          momentT.tz.guess() == "Asia/Kolkata") &&
                          (self.timeZone.tz_name == "Asia/Kolkata" ||
                            self.timeZone.tz_name == "Asia/Calcutta"));

                      y["lengthMinutes"] = lengthMinutes;
                      y["length"] = (lengthMinutes * 50) / 60;
                      y["start"] = self.newGetScreenPositionCalc(
                        y.ss_start_show_time,
                        y.ss_start_show_time.split(":")[1]
                      );

                      y["lang_name"] = y.language_name;
                      y["ss_show_status"] = y.ss_show_status;
                      y["selectedShowStatus"] = this.changeStatusArray.find(
                        (x) => x.status_id == y.ss_show_status
                      );
                      y["start_time"] = y.ss_start_show_time;
                      y["end_time"] = y.ss_end_show_time;
                      y["isNewSchedule"] = false;
                      y["sales_channel"] = y.sales_channel;
                      y["ss_comment"] = y.ss_comment;
                      y["sales_channel_changes"] = [];
                      y["AddonsCharges"] = y.AddonsCharges || [];
                      y["privateShowBookingDetails"] =
                        y.hasOwnProperty("privateShowBookingDetails") &&
                        y.privateShowBookingDetails
                          ? y.privateShowBookingDetails
                          : null;
                      y["admits"] = y.admits || 0;
                      y["mf_name"] = y.movie_format;
                    });
                  });
                });
                if (data.pdfPath && isPdf == "Y") {
              window.open(data.pdfPath, "_blank");
            }
              }
            })
            .catch((err) => {
              console.log("Err", err);
            })
            .finally(() => {
              loader.hide();
            });
        }
      },
      setModalData() {
        this.showModal = !this.showModal;
      },
      scrolfun() {
        this.topValue = event.srcElement.scrollTop;
      },
      getCinemaList: function(cine_id) {
        MasterService.GetCinemas({ cine_id: cine_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;
              if (data.Records && data.Records.length === 1) {
                this.onSelectCinema(data.Records[0]);
              }
            } else {
              this.$toasted.show(data.message);
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            console.log("Catch On GetActiveCinemas :", error);
          });
      },
      convertToTime: function(value, value1, screenMovie) {
        console.log(screenMovie);
        let totalMinutes = (this.movieSelected.start * 10) / 30;
        let _totalMinutes = Math.floor(
          totalMinutes + this.movieSelected.lengthMinutes
        );

        let _hours = Math.floor(_totalMinutes / 60);
        let _minutes = _totalMinutes % 60;
        let _ampm = "AM";
        if (_hours > 12) {
          _ampm = "PM";
          _hours = _hours - 12;
        }
        _minutes = _minutes >= 10 ? _minutes : "0" + _minutes;
        this.movieSelected.end_time = _hours + ":" + _minutes + " " + _ampm;

        let hours = Math.floor(totalMinutes / 60);
        let minutes = Math.floor(totalMinutes % 60);
        let ampm = "AM";
        if (hours > 12) {
          ampm = "PM";
          hours = hours - 12;
        }
        minutes = minutes >= 10 ? minutes : "0" + minutes;
        this.movieSelected.start_time = hours + ":" + minutes + " " + ampm;
        return hours + ":" + minutes + " " + ampm;
      },
      getDateTime(date, time) {
        return moment(new Date(date)).format("DD-MM-YYYY");
      },
      getAllActiveCinemas: function() {
        scheduleService
          .GetCinemas()
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.CinemasList = data.Records;
            } else {
              // Show Error message
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            this.$toasted.show(Error(error));
            console.log("Catch Error on getAllActiveCinemas :", error);
          });
      },
      getCinemaSetting: function(cinema_id) {
        console.log("cinema_id :", cinema_id);
        scheduleService
          .GetCinemaSetting({ cinema_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.CinemasSettings = {
                ...this.CinemasSettings,
                ...data.Records[0],
              };
              console.log("data.timeZone :", data.timeZone);
              this.timeZone = {
                ...this.timeZone,
                ...data.timeZone,
              };
              console.log(
                "this.CinemasSettings.cine_operation_start_time :",
                this.CinemasSettings.cine_operation_start_time
              );
              console.log(
                "this.CinemasSettings.cine_operation_end_time :",
                this.CinemasSettings.cine_operation_end_time
              );
              let startString = "";
              if (
                this.CinemasSettings.cine_operation_start_time.split(" ")[1] ==
                  "AM" ||
                this.CinemasSettings.cine_operation_start_time.split(" ")[1] ==
                  "PM"
              ) {
                startString = moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_start_time
                ).format("YYYY-MM-DD h:mm A");
              } else {
                startString = moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_start_time
                ).format("YYYY-MM-DD H:mm");
              }

              let endString = "";
              if (
                this.CinemasSettings.cine_operation_end_time.split(" ")[1] ==
                  "AM" ||
                this.CinemasSettings.cine_operation_end_time.split(" ")[1] ==
                  "PM"
              ) {
                endString = moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_end_time
                ).format("YYYY-MM-DD h:mm A");
              } else if (
                moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_start_time
                ).isSameOrAfter(
                  moment(
                    moment().format("YYYY-MM-DD") +
                      " " +
                      this.CinemasSettings.cine_operation_end_time
                  )
                )
              ) {
                endString = moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_end_time
                )
                  .add(1, "d")
                  .format("YYYY-MM-DD H:mm");
              } else if (
                this.CinemasSettings.cine_operation_end_time.split(":")[0] < 12
              ) {
                endString = moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_end_time
                )
                  .add(1, "d")
                  .format("YYYY-MM-DD H:mm");
              } else {
                endString = moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_end_time
                ).format("YYYY-MM-DD H:mm");
              }

              this.intervalsArray = intervals(startString, endString);

              function intervals(startString, endString) {
                var start = moment(startString, "YYYY-MM-DD hh:mm a");
                var end = moment(endString, "YYYY-MM-DD hh:mm a");

                start.minutes(Math.ceil(start.minutes() / 15) * 15);

                var result = [];

                var current = moment(start);
                end = moment(end);
                end.add(4 * 60, "minutes");
                while (current <= end) {
                  result.push(current.format("YYYY-MM-DD HH:mm"));
                  current.add(60, "minutes");
                }

                return result;
              }
            } else {
              // Show Message Here:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error on getCinemaSetting :", error);
          });
      },
      onSelectCinema: function(cinema) {
        this.cinemaId = cinema.cine_id;
        this.selectedCinema = cinema;
        this.selected.cinema = cinema.cine_name;
        this.selectedDuplicateCinema = cinema.cine_name;

        this.scheduleObject.cinema_id = cinema.cine_id;
        this.getCinemaSetting(cinema.cine_id);
        this.getRatecardsList(cinema.cine_id);
        this.getScheduleOverview();
        this.getAllAddonsCharges();
        this.getAllActiveScreens(cinema.cine_id);
      },
      getRatecardsList: function(cinema_id) {
        scheduleService
          .GetRatecardGroupByCinemaId({ cinema_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.RatecardsList = data.Records;
              this.RatecardsListCopy = data.Records;
            } else {
            }
          })
          .catch((error) => {
            console.log("Error", error);
          });
      },
      validateWeekDayRateCard() {
        let count = 0;
        let error = "";
        this.weekDaysArray.map((x) => {
          if (!x.hasOwnProperty("scheduling_price")) {
            count++;
            error = "Something Went Wrong!. Please Refresh and Try1.";
          }
          x.scheduling_price.map((y) => {
            console.log(y, "SchedulePricing");
            if (!y.rate_card_group_id) {
              count++;
              error = "Rate Card is Required.";
            } else if (!y.rate_card_id) {
              count++;
              error = "Rate Card Id is Required.";
            } else if (!y.screen_seat_type_id) {
              count++;
              error = " Screen Seat Type Id Missing.";
            }
          });
        });

        if (count > 0) {
          this.$toasted.show(error);
          return false;
        } else {
          return true;
        }
      },
      handleSingleDuplicateSchedule(action = "INSERT") {
        if (!this.singleDuplicateDetails.ss_start_date) {
          return this.$toasted.show("Please enter a start date");
        } else if (!this.singleDuplicateDetails.ss_end_date) {
          return this.$toasted.show("Please enter a to date");
        } else if (
          moment(this.singleDuplicateDetails.ss_start_date).isAfter(
            this.singleDuplicateDetails.ss_end_date
          )
        ) {
          return this.$toasted.show("From Date Must be Smaller than To Date");
        } else if (!this.validateWeekDayRateCard()) {
          return;
        } else {
          let loader = this.$loading.show();
          this.duplicateSubmitted = true;
          let MultipleSchedule = [];
          let moviesArray = [];
          let lengthMinutes =
            parseInt(this.selectedMultiShowSchedule.mrrdr_runtime) +
            parseInt(
              this.selectedMultiShowSchedule.cine_setting_ads_time_in_mins
            ) +
            parseInt(
              this.selectedMultiShowSchedule.cine_cleaning_time_in_mins
            ) +
            parseInt(this.selectedMultiShowSchedule.cine_interval_time_in_mins);
          this.selectedMultiShowSchedule["lengthMinutes"] = lengthMinutes;

          let mainObj = { ...this.selectedMultiShowSchedule };

          mainObj[
            "interval_time_in_mins"
          ] = this.selectedMultiShowSchedule.cine_interval_time_in_mins;
          mainObj[
            "cleaning_time_in_mins"
          ] = this.selectedMultiShowSchedule.cine_cleaning_time_in_mins;
          mainObj[
            "ads_time_in_mins"
          ] = this.selectedMultiShowSchedule.cine_setting_ads_time_in_mins;
          mainObj["cinema_id"] = this.scheduleObject.cinema_id;
          mainObj["screen_id"] = this.selectedScreen.screen_id;
          mainObj[
            "scheduling_price"
          ] = this.selectedMultiShowSchedule.scheduleShowPrice;

          moviesArray.push(mainObj);

          let obj = {
            moviesArray: moviesArray,
            screen_id: this.selectedScreen.screen_id,
            screen_name: this.selectedScreen.screen_name,
          };

          MultipleSchedule.push(obj);

          console.log("weekDaysArray", this.weekDaysArray);

          let payload = {
            WeekDays: this.weekDaysArray,
            CinemasSettings: this.CinemasSettings,
            timeZone: this.timeZone,
            ACTION: action,
            MultipleSchedule: MultipleSchedule,
            cinema_id: this.scheduleObject.cinema_id,
            sch_start_date: moment(
              this.singleDuplicateDetails.ss_start_date
            ).format("YYYY-MM-DD"),
            sch_end_date: moment(
              this.singleDuplicateDetails.ss_end_date
            ).format("YYYY-MM-DD"),
          };
          this.$validator.validate().then(async (valid) => {
            if (valid) {
              scheduleService
                .addMultipleSchedule(payload)
                .then((result) => {
                  const { data } = result;

                  if (data.status) {
                    if (action == "INSERT") {
                      this.$toasted.show(data.message);
                      this.$refs.DuplicateSingleSchedule.hide();
                      this.isChanged = false;
                      this.getSchedule();
                    }
                  } else {
                    this.$toasted.show(data.message);
                  }
                })
                .catch((err) => {
                  console.log("Error:", err);
                })
                .finally(() => {
                  loader.hide();
                });
            }
          });
        }
      },
      onSelectRateCardForDuplicateSchedule(
        rateCard,
        weekPrice,
        weekdaysLoop,
        weekPriceIndex
      ) {
        let obj = {
          rate_card_group_id: rateCard.rc_g_id || null,
          rate_card_id: rateCard.rc_id || null,
          rate_card_name: rateCard.rc_g_name || null,
          screen_seat_type_id: weekPrice.screen_seat_type_id,
          searchRateCard: "",
          selected_rate_card: {
            rc_g_id: rateCard.rate_card_group_id || null,
            rc_id: rateCard.rc_id || null,
            rc_g_name: rateCard.rc_g_name || null,
          },
          sst_seat_type: weekPrice.sst_seat_type,
        };

        if (weekdaysLoop.dayName == "selectAll") {
          this.weekDaysArray.forEach((y) => {
            Object.keys(y.scheduling_price[weekPriceIndex]).map((z) => {
              y.scheduling_price[weekPriceIndex][z] = obj[z] || null;
            });
          });
        } else {
          Object.keys(weekPrice).map((z) => {
            weekPrice[z] = obj[z] || null;
          });
        }

        this.$forceUpdate();
      },
      onChangeWeekdays: function(event, keyname) {
        this.weekdayerror = "";
        console.log("event :", event);
        if (keyname !== "selectAll") {
          this.weekDaysArray.forEach((x) => {
            if (x.dayName == "selectAll") {
              x["value"] = false;
            }
          });
        } else if (keyname == "selectAll") {
          this.weekDaysArray.forEach((x) => {
            if (x.dayName !== "selectAll") {
              x["value"] = event;
            }
          });
        }
      },
      onClickDuplicateSingleSchedule(schedule) {
        this.showFooterDetails = false;
        this.selectedMultiShowSchedule = schedule;
        if (schedule.isNewSchedule || this.scheduleObject.sch_start_date) {
          this.singleDuplicateDetails.ss_start_date = this.scheduleObject.sch_start_date;
          this.singleDuplicateDetails.ss_end_date = this.scheduleObject.sch_start_date;
        } else {
          this.singleDuplicateDetails.ss_start_date = new Date();
          this.singleDuplicateDetails.ss_end_date = new Date();
        }
        let tempArray = [];
        console.log(
          "onClickDuplicateSingleSchedule movieSelected",
          this.movieSelected
        );

        console.log(
          "this.selectedScreenSeatTypes",
          this.selectedScreenSeatTypes
        );

        this.selectedScreenSeatTypes.map((x) => {
          let obj = {
            rate_card_group_id: x.rate_card_group_id || null,
            rate_card_id: x.rate_card_id || null,
            rate_card_name: x.rate_card || null,
            screen_seat_type_id: x.sst_id,
            searchRateCard: "",
            selected_rate_card: {
              rc_g_id: x.rate_card_group_id || null,
              rc_id: x.rate_card_id || null,
              rc_g_name: x.rate_card || null,
            },
            sst_seat_type: x.sst_seat_type,
          };
          let newObj = {
            ...obj,
          };
          tempArray.push(newObj);
        });

        this.weekDaysArray.map((y, index) => {
          y["scheduling_price"] = [];
          y["value"] = true;
          tempArray.map((z) => {
            y["scheduling_price"].push({ ...z });
          });
        });
        console.log("this.weekDaysArray", this.weekDaysArray);
        this.$refs.DuplicateSingleSchedule.show();
        this.$forceUpdate();
      },
      onChangeShowStartTime: function(event) {
        console.log("event :", event);
        event = new Date(
          moment(event.displayTime, "HH:mm").format("YYYY-MM-DD, HH:mm:ss")
        );
        this.movieSelected["selected_time"] = event;
        this.$forceUpdate();
      },
      onClickViewDeletedScheduleDetails(showDetails) {
        this.deletedScheduleDetails = showDetails;
        this.$refs.deletedScheduleDetailsModal.show();
      },
      handleDuplicateSchedule: async function() {
        let self = this;
        this.$validator.validate().then(async (valid) => {
          if (valid) {
            this.FinalArray = [];
            let dates = getDates(
              moment(this.duplicate.ss_start_date).format("YYYY-MM-DD"),
              moment(this.duplicate.ss_end_date).format("YYYY-MM-DD")
            );
            this.FinalScreenAndMovieScheduleList = this.selectedMoviesInScreens.filter(
              (x) => {
                return x.movies.length > 0;
              }
            );

            function getDates(startDate, stopDate) {
              var dateArray = [];
              var currentDate = moment(startDate);
              var stopDate = moment(stopDate);
              while (currentDate <= stopDate) {
                dateArray.push(moment(currentDate).format("YYYY-MM-DD"));
                currentDate = moment(currentDate).add(1, "days");
              }
              console.log("dateArray :", dateArray);
              return dateArray;
            }

            let dateCount = 0;

            let finalpromises = self.FinalScreenAndMovieScheduleList.map(
              async (item, itemIndex) => {
                let MainObj = {};
                MainObj["screen_id"] = item.screen_id || null;
                MainObj["sch_is_active"] =
                  self.scheduleObject.sch_is_active || "Y";

                MainObj["scheduleshow"] = [];

                let moviePromises = item.movies.map(
                  async (movie, movieIndex) => {
                    MainObj["sch_start_date"] =
                      moment(self.duplicate.ss_start_date).format(
                        "YYYY-MM-DD"
                      ) || null;
                    MainObj["sch_end_date"] =
                      moment(self.duplicate.ss_end_date).format("YYYY-MM-DD") ||
                      null;

                    let promises = dates.map(async (date, dateIndex) => {
                      let MovieObj = {};
                      MovieObj["cinema_id"] = self.duplicate.cine_id
                        ? self.duplicate.cine_id
                        : self.scheduleObject.cinema_id;
                      MovieObj["screen_id"] = item.screen_id;
                      MovieObj["movie_details_id"] = movie.movie_details_id;
                      MovieObj["ss_show_status"] = movie.ss_show_status || 16;
                      MovieObj["interval_time_in_mins"] =
                        movie.interval_time_in_mins;
                      MovieObj["cleaning_time_in_mins"] =
                        movie.cleaning_time_in_mins;
                      MovieObj["ads_time_in_mins"] = movie.ads_time_in_mins;
                      MovieObj["isNewSchedule"] = true;

                      let totalMinutes = (movie.start * 10) / 30;
                      let _totalMinutes = totalMinutes + movie.lengthMinutes;
                      let _hours = Math.floor(_totalMinutes / 60);
                      let hours = Math.floor(totalMinutes / 60);
                      let minutes = totalMinutes % 60;
                      let _minutes = _totalMinutes % 60;
                      let ampm = "AM";
                      let _ampm = "AM";
                      if (hours > 12) {
                        ampm = "PM";
                        hours = hours - 12;
                      }

                      if (_hours > 12) {
                        _ampm = "PM";
                        _hours = _hours - 12; // this.tConvert(`${_hours - 12}:00`).digit; //
                      }
                      minutes = minutes >= 10 ? minutes : "0" + minutes;
                      _minutes = _minutes >= 10 ? _minutes : "0" + _minutes;

                      let showtime = format24Hours(date, movie.start_time);
                      let endShowtime = format24Hours(date, movie.end_time);
                      MovieObj["ss_start_show_time"] = showtime;
                      MovieObj["ss_end_show_time"] = endShowtime;
                      MovieObj["ss_start_date"] = moment(date).format(
                        "YYYY-MM-DD"
                      ); // movie.ss_start_date;
                      MovieObj["ss_start_date_time"] = +new Date(
                        moment(date).format("YYYY-MM-DD") +
                          "T" +
                          showtime +
                          this.timeZone.tz_utc_offset
                      );
                      MovieObj["ss_is_active"] = movie.ss_is_active || "Y"; // movie.ss_end_date_time;
                      //actual date
                      if (
                        moment(
                          moment().format("YYYY-MM-DD") +
                            " " +
                            self.CinemasSettings.cine_operation_start_time
                        ).isSameOrAfter(
                          moment(
                            moment().format("YYYY-MM-DD") +
                              " " +
                              self.CinemasSettings.cine_operation_end_time
                          )
                        )
                      ) {
                        if (
                          moment(
                            moment().format("YYYY-MM-DD") +
                              " " +
                              self.CinemasSettings.cine_operation_end_time
                          ).isAfter(
                            moment(
                              moment().format("YYYY-MM-DD") +
                                " " +
                                movie.start_time
                            )
                          )
                        ) {
                          MovieObj["ss_actual_start_date"] = moment(date)
                            .add(1, "days")
                            .format("YYYY-MM-DD");
                          MovieObj["ss_actual_start_date_time"] = +new Date(
                            moment(date)
                              .add(1, "days")
                              .format("YYYY-MM-DD") +
                              "T" +
                              showtime +
                              this.timeZone.tz_utc_offset
                          );
                          MovieObj["ss_actual_end_date"] = moment(date)
                            .add(1, "days")
                            .format("YYYY-MM-DD");
                          MovieObj["ss_actual_end_date_time"] = +new Date(
                            moment(date)
                              .add(1, "days")
                              .format("YYYY-MM-DD") +
                              "T" +
                              endShowtime +
                              this.timeZone.tz_utc_offset
                          );
                          MovieObj["ss_end_date"] = moment(date)
                            .add(1, "days")
                            .format("YYYY-MM-DD");

                          MovieObj["ss_end_date_time"] = +new Date(
                            moment(date)
                              .add(1, "days")
                              .format("YYYY-MM-DD") +
                              "T" +
                              endShowtime +
                              this.timeZone.tz_utc_offset
                          );
                        } else {
                          MovieObj["ss_actual_start_date"] = moment(
                            date
                          ).format("YYYY-MM-DD");
                          MovieObj["ss_actual_start_date_time"] = +new Date(
                            moment(date).format("YYYY-MM-DD") +
                              "T" +
                              showtime +
                              this.timeZone.tz_utc_offset
                          );
                          MovieObj["ss_actual_end_date"] =
                            movie.start_time.split(" ")[1] == "PM" &&
                            movie.end_time.split(" ")[1] == "AM"
                              ? moment(date)
                                  .add(1, "days")
                                  .format("YYYY-MM-DD")
                              : moment(date).format("YYYY-MM-DD");
                          MovieObj["ss_actual_end_date_time"] =
                            movie.start_time.split(" ")[1] == "PM" &&
                            movie.end_time.split(" ")[1] == "AM"
                              ? +new Date(
                                  moment(date)
                                    .add(1, "days")
                                    .format("YYYY-MM-DD") +
                                    "T" +
                                    endShowtime +
                                    this.timeZone.tz_utc_offset
                                )
                              : +new Date(
                                  moment(date).format("YYYY-MM-DD") +
                                    "T" +
                                    endShowtime +
                                    this.timeZone.tz_utc_offset
                                );
                          MovieObj["ss_end_date"] =
                            movie.start_time.split(" ")[1] == "PM" &&
                            movie.end_time.split(" ")[1] == "AM"
                              ? moment(date)
                                  .add(1, "days")
                                  .format("YYYY-MM-DD")
                              : moment(date).format("YYYY-MM-DD");

                          MovieObj["ss_end_date_time"] =
                            movie.start_time.split(" ")[1] == "PM" &&
                            movie.end_time.split(" ")[1] == "AM"
                              ? +new Date(
                                  moment(date)
                                    .add(1, "days")
                                    .format("YYYY-MM-DD") +
                                    "T" +
                                    endShowtime +
                                    this.timeZone.tz_utc_offset
                                )
                              : +new Date(
                                  moment(date).format("YYYY-MM-DD") +
                                    "T" +
                                    endShowtime +
                                    this.timeZone.tz_utc_offset
                                );
                        }
                      } else {
                        MovieObj["ss_actual_end_date"] =
                          movie.start_time.split(" ")[1] == "PM" &&
                          movie.end_time.split(" ")[1] == "AM"
                            ? moment(date)
                                .add(1, "days")
                                .format("YYYY-MM-DD")
                            : moment(date).format("YYYY-MM-DD");
                        MovieObj["ss_actual_start_date"] = moment(date).format(
                          "YYYY-MM-DD"
                        );
                        MovieObj["ss_actual_end_date_time"] =
                          movie.start_time.split(" ")[1] == "PM" &&
                          movie.end_time.split(" ")[1] == "AM"
                            ? +new Date(
                                moment(date)
                                  .add(1, "days")
                                  .format("YYYY-MM-DD") +
                                  "T" +
                                  endShowtime +
                                  this.timeZone.tz_utc_offset
                              )
                            : +new Date(
                                moment(date).format("YYYY-MM-DD") +
                                  "T" +
                                  endShowtime +
                                  this.timeZone.tz_utc_offset
                              );
                        MovieObj["ss_actual_start_date_time"] = +new Date(
                          moment(date).format("YYYY-MM-DD") +
                            "T" +
                            showtime +
                            this.timeZone.tz_utc_offset
                        );
                        MovieObj["ss_end_date"] =
                          movie.start_time.split(" ")[1] == "PM" &&
                          movie.end_time.split(" ")[1] == "AM"
                            ? moment(date)
                                .add(1, "days")
                                .format("YYYY-MM-DD")
                            : moment(date).format("YYYY-MM-DD");

                        MovieObj["ss_end_date_time"] =
                          movie.start_time.split(" ")[1] == "PM" &&
                          movie.end_time.split(" ")[1] == "AM"
                            ? +new Date(
                                moment(date)
                                  .add(1, "days")
                                  .format("YYYY-MM-DD") +
                                  "T" +
                                  endShowtime +
                                  this.timeZone.tz_utc_offset
                              )
                            : +new Date(
                                moment(date).format("YYYY-MM-DD") +
                                  "T" +
                                  endShowtime +
                                  this.timeZone.tz_utc_offset
                              );
                      }

                      //

                      MovieObj["ss_start_date_time"] = +new Date(
                        moment(date).format("YYYY-MM-DD") +
                          "T" +
                          showtime +
                          this.timeZone.tz_utc_offset
                      );

                      console.log(
                        'moment(date).format("YYYY-MM-DD") + " " + endShowtime :',
                        moment(date).format("YYYY-MM-DD") +
                          "T" +
                          showtime +
                          this.timeZone.tz_utc_offset
                      );
                      console.log(
                        ' MovieObj["ss_start_date_time"]',
                        MovieObj["ss_start_date_time"]
                      );

                      console.log("endShowtime :", endShowtime);
                      console.log(
                        'MovieObj["ss_end_date_time"]  :',
                        MovieObj["ss_end_date_time"]
                      );
                      MovieObj["ss_is_active"] = movie.ss_is_active || "Y"; // movie.ss_end_date_time
                      // array scheduleshowprice
                      MovieObj["scheduleshowprice"] = [];
                      let scheduleShowPricePromises = movie.scheduleShowPrice.map(
                        (price, priceIndex) => {
                          let PriceObj = {};

                          dateCount = PriceObj[
                            "cinema_id"
                          ] = this.scheduleObject.cinema_id;
                          PriceObj["screen_id"] = item.screen_id;
                          PriceObj["md_id"] = movie.movie_details_id;
                          PriceObj["rate_card_id"] = price.rate_card_id;
                          PriceObj["rate_card_group_id"] =
                            price.rate_card_group_id;
                          PriceObj["screen_seat_type_id"] =
                            price.screen_seat_type_id;
                          PriceObj["p_start_date_time"] =
                            price.p_start_date_time; // price.p_start_date_time;
                          PriceObj["p_end_date_time"] = price.p_end_date_time; // price.p_end_date_time;
                          PriceObj["p_is_active"] = price.p_is_active || "Y";

                          // Push Show Price
                          MovieObj["scheduleshowprice"].push(PriceObj);
                        }
                      );
                      await Promise.all(scheduleShowPricePromises);

                      // Push Show and Show Price
                      MainObj["scheduleshow"].push(MovieObj);
                    });
                    await Promise.all(promises);
                  }
                );
                await Promise.all(moviePromises);
                // Final Array Push
                this.FinalArray.push(MainObj);
                console.log("this.FinalArray :", this.FinalArray);
              }
            );

            function format24Hours(date, time) {
              let newVal = date + " " + time;
              let finalVal = moment(newVal).format("HH:mm");
              return finalVal;
            }

            function toUnixTimeStamp(Datestring) {
              console.log("Datestring :", Datestring);
              return new Date(Datestring.toString()).getTime() / 1000;
            }
            // console.log("this.FinalArray :", this.FinalArray);

            this.btenable = true;
            await Promise.all(finalpromises)
              .then((result) => {
                let loader = this.$loading.show();

                console.log("this.FinalArray :", this.FinalArray);
                this.FinalArray.map((x) => {
                  scheduleService
                    .AddSchedule(x)
                    .then((resp) => {
                      this.btenable = false;
                      loader.hide();
                      const { data } = resp;
                      if (data && data.status) {
                        this.duplicate.cine_id = null;
                        this.$refs.duplicateModal.hide();
                        this.$toasted.show(
                          "Thank You! Your show has been duplicated"
                        );
                        // this.$toasted.show(data.message);
                      } else {
                        this.$toasted.show(data.message);
                      }
                    })
                    .catch((err) => {
                      this.$toasted.show(err);
                    });
                });
              })
              .catch((err) => {
                this.$toasted.show(err);
              });
            // this.onFinalSubmit();
          }
        });
      },
      clear_ss_start_date() {
        this.duplicate.ss_start_date = "";
      },
      clear_ss_end_date() {
        this.duplicate.ss_end_date = "";
      },
      clear_singleduplicateDates(type) {
        console.log("Clearing dates");
        if (type == "start") {
          this.singleDuplicateDetails.ss_start_date = "";
        } else if (type == "end") {
          this.singleDuplicateDetails.ss_end_date = "";
        }
      },
      duplicateSchedule: function() {
        this.duplicate.ss_start_date = "";
        this.duplicate.ss_end_date = "";
        this.$refs.duplicateModal.show();
      },
      openImageModal: function() {
        this.$refs["preview-modal"].show();
      },
      setModalData() {
        this.showModal = !this.showModal;
      },
      getCurrencyCode() {
        let payload = {
          tableName: "ms_currencies",
          curr_is_active: "Y",
          curr_id:
            this.secureStore.get("BRGLOPCU") &&
            this.secureStore.get("BRGLOPCU").go_value,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.currencyData = data.Records[0];
            } else {
              // Show Error Message:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error on getActiveScreenByCinemaId :", error);
          });
      },
      handleEnableDisableSch(sch) {
        let payload = {
          md_id: sch.md_id,
          ss_id: sch.ss_id,
          type: sch.is_sch_disable == "N" ? 1 : 2,
        };

        MasterService.EnableDisableSchedule(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.getScheduleOverview();
            } else {
              cosole.log("Error Message", data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            this.$bvModal.hide("enableDisableSchedule");
          });
      },
      onClickEnableDisableSchedule(schedule) {
        this.showFooterDetails = false;
        let type = schedule.is_sch_disable == "N" ? 1 : 2;
        this.selectedSchedule = schedule;
        this.scheduleStatusType = type;

        if (schedule.booked_seats && schedule.booked_seats > 0) {
          return this.$toasted.show(
            `(${schedule.booked_seats}) transaction(s) found for this show. Please apply for refund module.`
          );
        } else if (schedule.unpaid_count && schedule.unpaid_count > 0) {
          return this.$toasted.show(
            `(${schedule.unpaid_count}) Unpaid transaction(s) found, Please Cancel Unpaid Booking.`
          );
        } else {
          this.$refs["enableDisableSchedule"].show();
        }
      },
    },
  };
</script>

<style>
  .dropup .dropdown-toggle::after {
    border-right: 0em solid transparent !important;
    border-bottom: 0em solid !important;
    border-left: 0em solid transparent !important;
  }
  .grid-seat-buttons {
    display: grid;
    grid-template-columns: repeat(10, 10%);
    /* justify-content: center; */
    justify-items: center;
    align-items: baseline;
  }

  .grid-seat-buttons .pos-seat {
    width: 30px;
  }

  .grid-seat-buttons p {
    text-align: center;
    margin-bottom: 0;
    font-size: 10px;
    padding-top: 5px;
    line-height: 14px;
  }
  .color-box {
    width: 15px;
    height: 15px;
    margin-bottom: 10px;
  }
  .color-combination {
    font-size: 12px;
  }

  .date-arrow {
    padding-top: 8px;
    z-index: 100;
  }

  .date-arrow-left {
    margin-right: -10px;
  }

  .date-arrow-right {
    margin-left: -10px;
  }

  .delete-schedule-content {
    /* display: grid !important; */
    grid-template-columns: 62% 35% !important;
    /* overflow: hidden; */
    height: 100%;
  }
  .delete-schedule-card {
    padding: 05px !important;
  }

  .delete-schedule-content img {
    max-width: 60px !important;
  }

  .h-50 {
    height: 50px !important;
  }

  .btn-delete {
    background: darkred !important;
    color: white !important;
    border: none !important;
  }

  .btn-planned {
    background: rgb(254, 255, 0) !important;
    color: black !important;
    border: none !important;
  }

  .btn-planned:hover {
    background: white !important;
    color: #c4b63d !important;
    border: 1px solid #c4b63d !important;
  }

  .disDeleteBtn {
    opacity: 0.4 !important;
  }

  .btn-delete:hover {
    background: white !important;
    color: darkred !important;
    border: 1px solid darkred !important;
  }

  .selected-border {
    border: 2px solid darkred !important;
  }

  .h-29 {
    height: 29px !important;
  }

  .w-60 {
    width: 60px !important;
  }

  .w-40 {
    width: 40px !important;
  }
  .fs-13 {
    font-size: 13px;
  }

  .br-20 {
    border-radius: 20px !important;
  }

  .plus-minus-btn {
    color: #fff;
    border: none;
    display: block;
    font-size: 35px;
    padding: 0 10px;
    margin: 0 15px;
    border-radius: 8px;
    background-color: var(--primary);
  }

  .lh {
    line-height: 1.4;
  }

  .ellipsisText {
    width: 70%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .zIndex11 {
    z-index: 11 !important;
  }

  .schedule-overview-table {
    /* width: 100%; */
    table-layout: auto !important;
    white-space: nowrap;
    border-radius: 10px;
    margin-bottom: 50px;
    background-color: #fff;
  }
  .schedule-overview-table-time {
    /*width: 53px;*/
    table-layout: auto !important;
    white-space: nowrap;
    border-radius: 10px;
    margin-bottom: 50px;
    background-color: #fff;
  }
  .table-header-row {
    background: #6f87ab;
    color: white;
    text-align: center;
  }
  .table-header-row-color {
    background: #6f87ab;
    color: white;
  }
  .table-header-subcol {
    background: #7facef;
    color: white;
    text-align: center;
  }
  .table-header-row th {
    width: 180px;
  }

  .br-10 {
    border-radius: 10px;
  }

  .w-400 {
    /* width: 400px; */

    min-width: 160px;
    width: 100%;
  }

  .movie-box {
    cursor: "pointer";
    height: 95px;
    margin: auto;
    width: 90%;
    max-width: 150px;
    border-radius: 10px;
    box-shadow: 1px 1px 1px 1px;
  }

  .screenCol {
    border-right: 1px solid lightgray;
    min-width: 180px;
    /* height: calc(100vh - 90px); */
  }

  .screenCol:last-child {
    /* border: none; */
  }

  .screenCol-time {
    border-right: 1px solid lightgray;
    min-width: 40px;
    max-width: 45px;
    /* height: calc(100vh - 90px); */
  }

  .screenCol-time:last-child {
    border: none;
  }
  .blue-icon {
    cursor: pointer;
  }

  .b-1 {
    border-bottom: 1px solid lightgray;
  }

  .status-red-2 {
    background: #ff000026;
  }

  .status-yellow-2 {
    background: #ffd70042;
  }

  .status-green-2 {
    background: lightgreen;
  }
  .status-private {
    background: #add8e6;
  }

  .status-lightgreen-2 {
    background: #88f58842;
  }

  .status-grey-2 {
    background: #b5b6b742;
  }

  .br1 {
    border-right: 1px solid #000;
  }

  .cell {
    border-collapse: collapse;
    border: 1px solid lightgrey;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 5px 10px;
  }

  .cell:last-child,
  .cell:first-child {
    border-bottom: none;
  }

  .rc-details {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .listviewtable {
    /* table-layout: fixed !important; */
    width: 100%;
  }

  .listviewtable th,
  .listviewtable td {
    padding: 5px 10px 5px 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .w-250 {
    width: 250px;
  }

  .disableViewBtn {
    /* opacity: 0.4; */
    cursor: not-allowed;
  }

  .listviewtable table th,
  .listviewtable table td {
    text-align: left !important;
  }

  .zoomInBtnl {
    cursor: pointer;
    display: inline-block;
    vertical-align: top;
    color: black;
    margin-right: 9px;
    width: 26px;
    height: 26px;
    line-height: 22px;
    font-size: 30px;
    font-family: monospace;
    text-align: center;
    border-radius: 50%;
    background: #c9c9c9;
  }

  .zoomInBtnl.disable {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .listScreenName {
    background: #f7d69973;
    font-weight: 500;
  }

  .w-62 {
    width: 62px;
    min-width: 62px;
    max-width: 62px;
  }

  .w-60 {
    width: 60px;
    min-width: 60px;
    max-width: 60px;
  }

  .w-115 {
    width: 115px;
    min-width: 115px;
    max-width: 115px;
  }

  .my-popover-class .popover-header {
    background-color: #00adff29;
  }

  .my-popover-class {
    max-width: 360px !important;
  }

  .rowDivider {
    border-bottom: 1px solid blue;
  }
  .box-size-screen {
    vertical-align: initial;
    padding: 14px;
    position: relative;
  }

  .box-size-screen-time {
    vertical-align: initial;
    padding-top: 14px;
    position: relative;
  }
  .hour-border {
    border-top: 1px solid lightgray;
  }
  .horizontal_line {
    background-color: lightgray;
    width: 200vw;
    max-width: 200vw;
    margin: 0px;
  }
  .hidden {
    overflow-x: hidden;
  }
  .dropright .dropdown-toggle:empty::after {
    opacity: 0;
  }
  .border-table {
    border-left: 1px solid #000 !important;
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
  }

  .indicator-border {
    box-shadow: inset -4px 0px 0px 0px orange !important;
    box-sizing: border-box !important;
  }

  .zoom06 {
    zoom: 0.6;
  }
  .zoom08 {
    zoom: 0.8;
  }
  .zoom12 {
    zoom: 1.2;
  }

  /*Different Drop */
  .zoom06_new {
    zoom: 1.2;
  }
  .zoom08_new {
    zoom: 1.2;
  }
  .pdf_table th {
    text-align: center;
    border: 1px solid grey;
  }
  .cursor-pointer{
    cursor:pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ScheduleComponents/ViewScheduleOverview.vue